const t = {}

t.loading = '加载中...'

t.brand = {}
t.brand.lg = 'BMW 悦学苑'
t.brand.mini = ''

t.add = '新增'
t.delete = '删除'
t.deleteBatch = '删除'
t.update = '编辑'
t.view = '查看'
t.query = '查询'
t.reset = '重置'
t.export = '导出'
t.exportAll = '全部导出'
t.handle = '操作'
t.confirm = '确定'
t.cancel = '取消'
t.logout = '退出'
t.tmpStorage = '暂存'
t.remove = '删除'
t.checkAll = '全选'
t.dealWith = '反馈'
t.save = '保存'
t.check = '验证'
t.finish = '完成'

t.prompt = {}
t.prompt.title = '提示'
t.prompt.titleprice = '费用结算页'
t.prompt.info = '确定进行[{handle}]操作?'
t.prompt.position = '确定进行{删除}操作?如果删除此岗位,跟此岗位有关人员的数据将受到影响'
t.prompt.role = '确定进行{删除}操作?如果删除此角色,跟此角色有关人员的数据将受到影响'
t.prompt.success = '操作成功'
t.prompt.failed = '操作失败'
t.prompt.deleteBatch = '请选择删除项'

t.validate = {}
t.validate.required = '必填项不能为空'
t.validate.captchaRequired = '请输入有效的6位数验证码'
t.validate.format = '{attr}格式错误'
t.validate.isPassword = '密码长度为15-30位，可以使用大小写字母，数字，特殊字符(& * - # _ )'
t.validate.isPasswordIam = '密码长度为15-30位，可以使用大小写字母，数字，特殊字符(& * - # _ )'
t.validate.isNumOrEn = '请输入半角英文字母或半角数字'
t.validate.validateIP = '请输入正确的IP地址'
t.validate.validateZipCode = '请输入正确的邮编'
t.validate.validatePhoneTwo = '请输入电话或固话号码(格式:区号-号码,如0411-1234567)'
t.validate.validateTelphone = '请输入正确的固话（格式：区号+号码,如010-1234567）'
t.validate.validateIdNo = '请输入正确的证件编号'
t.validate.validateEMail = '请输入正确的邮箱地址'
t.validate.validatePhoneSame = '修改后的手机不可与之前相同'
t.validate.validateMailSame = '修改后的邮箱不可与之前相同'
t.validate.checkMax20000 = '请输入[1,20000]之间的数字'
t.validate.checkMaxVal = '请输入[0,32767]之间的数字'
t.validate.notNull = '输入不可以为空'
t.validate.positiveInteger = '请输入正整数'
t.validate.isOneToNinetyNine = '请输入正整数，值为【1,99】'
t.validate.isDecimal = '请输入[0,1]之间的数字'
t.validate.isBtnOneToTen = '请输入正整数，值为【1,10】'
t.validate.isBtnZeroToHundred = '请输入[1,100]之间的数字'
t.validate.isPortNotNull = '请输入端口值'
t.validate.isPort = '请输入在[0-65535]之间的端口值'
t.validate.isCheckPort = '请输入在[0-65535]之间的端口值'
t.validate.validateMobile = '请输入正确的手机'
// t.validate.validateMobile = '请输入正确的手机/邮箱'
t.validate.validatePhone = '电话号码格式错误'
t.validate.validateLength = '最多输入{handle}位'
t.validate.isSpecialCharacters = '输入的内容不能包含特殊字符'
t.validate.agreement = '请先同意用户协议'
t.validate.taskApproved = '请填写审批意见'
t.validate.taskNotNull = '此用户名下有待办任务，是否确认离职？'
t.validate.courseNotNull = '此用户名下有已报名的F2F课程，是否取消课程，并确认离职？'
t.validate.courseTaskNotNull = '此用户名下有已报名的F2F课程，且有待办任务，是否取消课程，并确认离职？'
t.validate.validateIsNum = '请输入数字'

t.upload = {}
t.upload.text = '将文件拖到此处，或<em>点击上传</em>'
t.upload.tip = '只支持{format}格式文件！'
t.upload.button = '点击上传'

t.datePicker = {}
t.datePicker.range = '至'
t.datePicker.start = '开始日期'
t.datePicker.end = '结束日期'

t.fullscreen = {}
t.fullscreen.prompt = '您的浏览器不支持此操作'

t.updatePassword = {}
t.updatePassword.title = '修改密码'
t.updatePassword.username = '账号'
t.updatePassword.password = '原密码'
t.updatePassword.newPassword = '新密码'
t.updatePassword.comfirmPassword = '确认密码'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = '两次输入的密码不一致，请检查后重新输入。'
t.updatePassword.revoke = '身份验证'

t.identity = {}
t.identity.checktitle = '身份验证'
t.identity.modifyMobile = '修改手机'
t.identity.modifyMail = '修改邮箱'
t.identity.imgUpload = '图片上传'
t.identity.imgUploadTip = '请上传一寸照片，此照片用于头像展示和荣誉证书'

t.contentTabs = {}
t.contentTabs.closeCurrent = '关闭当前标签页'
t.contentTabs.closeOther = '关闭其它标签页'
t.contentTabs.closeAll = '关闭全部标签页'

/* 页面 */
t.notFound = {}
t.notFound.desc = '抱歉！您访问的页面<em>失联</em>啦...'
t.notFound.back = '上一页'
t.notFound.home = '首页'

t.login = {}
t.login.title = '登录'
t.login.username = '用户名'
t.login.password = '密码'
t.login.captcha = '验证码'
t.login.demo = '在线演示'
t.login.copyright = '开源'

t.home = {}
t.home.desc = {}
t.home.desc.title = '项目介绍'
t.home.desc.list = [
  'BMW 悦学苑',
  '宝马(BMW)是享誉世界的豪华汽车品牌。宝马的车系有1、2、3、4、5、6、7、8、i、X、Z等几个系列，还有在各系基础上进行改进的M系（宝马官方的高性能改装部门）。',
  '宝马公司创建于1916年，总部设在德国巴伐利亚州慕尼黑。BMW的蓝白标志宝马总部所在地巴伐利亚州州旗的颜色。百年来，宝马汽车由最初的一家飞机引擎生产厂发展成为以高级轿车为主导，并生产享誉全球的飞机引擎、越野车和摩托车的企业集团，名列世界汽车公司前列。其全称为Bavarian Motor Work。',
  '2018年7月10日，长城公司与宝马公司签署合资协议，合资成立光束汽车有限公司。2018年10月11日，宝马集团举行了中国战略协议签字仪式和华晨宝马铁西新工厂开工仪式。宝马对华晨宝马投资新增30亿欧元，合资协议延至2040年。',
  '2018年12月18日，世界品牌实验室编制的《2018世界品牌500强》揭晓，宝马排名第16位。'
]
/* 模块 */
t.model = {}
t.model.name = '名称'
t.model.paramKey = '键值'
t.model.paramValue = '值'
t.model.key = '标识'
t.model.version = '版本'
t.model.createTime = '创建时间'
t.model.lastUpdateTime = '更新时间'
t.model.design = '在线设计'
t.model.deploy = '部署'
t.model.description = '描述'

t.process = {}
t.process.name = '名称'
t.process.key = '标识'
t.process.deployFile = '部署流程文件'
t.process.id = '流程ID'
t.process.deploymentId = '部署ID'
t.process.version = '版本'
t.process.resourceName = 'XML'
t.process.diagramResourceName = '图片'
t.process.deploymentTime = '部署时间'
t.process.active = '激活'
t.process.suspend = '挂起'
t.process.convertToModel = '转换为模型'

t.running = {}
t.running.id = '实例ID'
t.running.definitionKey = '定义Key'
t.running.processDefinitionId = '定义ID'
t.running.processDefinitionName = '定义名称'
t.running.activityId = '当前环节'
t.running.suspended = '是否挂起'
t.running.suspended0 = '否'
t.running.suspended1 = '是'
t.running.labelSuspended0 = '不活动'
t.running.labelSuspended1 = '活动'

t.schedule = {}
t.schedule.beanName = 'bean名称'
t.schedule.beanNameTips = 'spring bean名称, 如: testTask'
t.schedule.pauseBatch = '暂停'
t.schedule.resumeBatch = '恢复'
t.schedule.runBatch = '执行'
t.schedule.log = '日志列表'
t.schedule.params = '参数'
t.schedule.cronExpression = 'cron表达式'
t.schedule.cronExpressionTips = '如: 0 0 12 * * ?'
t.schedule.remark = '备注'
t.schedule.status = '状态'
t.schedule.status0 = '暂停'
t.schedule.status1 = '正常'
t.schedule.statusLog0 = '失败'
t.schedule.statusLog1 = '成功'
t.schedule.pause = '暂停'
t.schedule.resume = '恢复'
t.schedule.run = '执行'
t.schedule.jobId = '任务ID'
t.schedule.times = '耗时(单位: 毫秒)'
t.schedule.createDate = '执行时间'

t.bulkmail = {}
t.bulkmail.check = '查看'
t.bulkmail.copy = '复制'
t.bulkmail.edit = '编辑'
t.bulkmail.send = '发送'
t.bulkmail.resend = '发送'
t.bulkmail.output = '导出'
t.bulkmail.delete = '删除'
t.bulkmail.title = '标题'
t.bulkmail.annex = '附件'
t.bulkmail.text = '正文'
t.bulkmail.mailTheme = '邮件主题'
t.bulkmail.mailContent = '邮件内容'
t.bulkmail.sendTime = '发送时间'
t.bulkmail.splitState = '拆分状态'
t.bulkmail.sendType = '邮件类型'
t.bulkmail.sendState = '发送状态'
t.bulkmail.createTime = '创建时间'
t.bulkmail.createUser = '创建人姓名'
t.bulkmail.sendUser = '发件人'
t.bulkmail.add = '拆分设置'
t.bulkmail.upload = '检查并拆分'
t.bulkmail.no = '序号'
t.bulkmail.fileName = '文件名'
t.bulkmail.orgIdAndNSCNO = '组织编号/NSC No.'
t.bulkmail.ccSender = '抄送发件人'
t.bulkmail.mailType = '邮件类型'
t.bulkmail.addresseeGroup = '收件人组群'
t.bulkmail.addresseePosition = '收件人职位'
t.bulkmail.addresseeRole = '收件人角色'
t.bulkmail.sendTypeTo = '发送方式'
t.bulkmail.addToList = '添加到列表'
t.bulkmail.tableState = '类型'
t.bulkmail.tableStateVal = '类型名称'
t.bulkmail.positionStateVal = '职位类型值'
t.bulkmail.roleStateVal = '角色类型值'
t.bulkmail.step1 = '主题和正文'
t.bulkmail.step2 = '选择收件人'
t.bulkmail.step3 = '拆分设置'
t.bulkmail.step4 = '发送清单'
t.bulkmail.nextStep = '下一步'
t.bulkmail.sendAll = '全部发送'
t.bulkmail.cancel = '取消'
t.bulkmail.partTimeFlag = '主要职位'
t.bulkmail.userStatus = '收件人状态'
t.bulkmail.insertText = '插入公司简称'
t.bulkmail.mailNum = '邮件数量（成功/总数）'
t.bulkmail.toUserMail = '收件人'
t.bulkmail.ccUserMail = '抄送'
t.bulkmail.bccUserMail = '密送'
t.bulkmail.mailExport = '批量邮件导出'
t.bulkmail.mailSplit = '拆分邮件导出'
t.bulkmail.mailGroup = '组群邮件导出'
t.bulkmail.mailLogExport = '拆分日志导出'
t.bulkmail.createUserCode = '创建人ID'

t.mail = {}
t.mail.name = '名称'
t.mail.config = '邮件配置'
t.mail.subject = '主题'
t.mail.createDate = '创建时间'
t.mail.send = '发送邮件'
t.mail.content = '内容'
t.mail.smtp = 'SMTP'
t.mail.port = '端口号'
t.mail.username = '邮箱账号'
t.mail.password = '邮箱密码'
t.mail.mailTo = '收件人'
t.mail.mailCc = '抄送'
t.mail.params = '模板参数'
t.mail.paramsTips = '如：{"code": "123456"}'
t.mail.templateId = '模版ID'
t.mail.status = '状态'
t.mail.status0 = '发送失败'
t.mail.status1 = '发送成功'
t.mail.mailFrom = '发送者'
t.mail.createDate = '发送时间'

t.sms = {}
t.sms.mobile = '手机'
t.sms.status = '状态'
t.sms.status0 = '发送失败'
t.sms.status1 = '发送成功'
t.sms.config = '短信配置'
t.sms.send = '发送短信'
t.sms.platform = '平台类型'
t.sms.platform1 = '阿里云'
t.sms.platform2 = '腾讯云'
t.sms.params = '参数'
t.sms.paramsTips = '如：{"code": "123456"}'
t.sms.params1 = '参数1'
t.sms.params2 = '参数2'
t.sms.params3 = '参数3'
t.sms.params4 = '参数4'
t.sms.createDate = '发送时间'
t.sms.aliyunAccessKeyId = 'Key'
t.sms.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.sms.aliyunAccessKeySecret = 'Secret'
t.sms.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.sms.aliyunSignName = '短信签名'
t.sms.aliyunTemplateCode = '短信模板'
t.sms.aliyunTemplateCodeTips = '短信模板CODE'
t.sms.qcloudAppId = 'AppId'
t.sms.qcloudAppIdTips = '腾讯云AppId'
t.sms.qcloudAppKey = 'AppKey'
t.sms.qcloudAppKeyTips = '腾讯云AppKey'
t.sms.qcloudSignName = '短信签名'
t.sms.qcloudTemplateId = '短信模板'
t.sms.qcloudTemplateIdTips = '短信模板ID'

t.oss = {}
t.oss.config = '云存储配置'
t.oss.upload = '上传文件'
t.oss.url = 'URL地址'
t.oss.createDate = '创建时间'
t.oss.type = '类型'
t.oss.type1 = '七牛'
t.oss.type2 = '阿里云'
t.oss.type3 = '腾讯云'
t.oss.type4 = 'FastDFS'
t.oss.type5 = '本地上传'
t.oss.qiniuDomain = '域名'
t.oss.qiniuDomainTips = '七牛绑定的域名'
t.oss.qiniuPrefix = '路径前缀'
t.oss.qiniuPrefixTips = '不设置默认为空'
t.oss.qiniuAccessKey = 'AccessKey'
t.oss.qiniuAccessKeyTips = '七牛AccessKey'
t.oss.qiniuSecretKey = 'SecretKey'
t.oss.qiniuSecretKeyTips = '七牛SecretKey'
t.oss.qiniuBucketName = '空间名'
t.oss.qiniuBucketNameTips = '七牛存储空间名'
t.oss.aliyunDomain = '域名'
t.oss.aliyunDomainTips = '阿里云绑定的域名'
t.oss.aliyunPrefix = '路径前缀'
t.oss.aliyunPrefixTips = '不设置默认为空'
t.oss.aliyunEndPoint = 'EndPoint'
t.oss.aliyunEndPointTips = '阿里云EndPoint'
t.oss.aliyunAccessKeyId = 'AccessKeyId'
t.oss.aliyunAccessKeyIdTips = '阿里云AccessKeyId'
t.oss.aliyunAccessKeySecret = 'AccessKeySecret'
t.oss.aliyunAccessKeySecretTips = '阿里云AccessKeySecret'
t.oss.aliyunBucketName = 'BucketName'
t.oss.aliyunBucketNameTips = '阿里云BucketName'
t.oss.qcloudDomain = '域名'
t.oss.qcloudDomainTips = '腾讯云绑定的域名'
t.oss.qcloudPrefix = '路径前缀'
t.oss.qcloudPrefixTips = '不设置默认为空'
t.oss.qcloudAppId = 'AppId'
t.oss.qcloudAppIdTips = '腾讯云AppId'
t.oss.qcloudSecretId = 'SecretId'
t.oss.qcloudSecretIdTips = '腾讯云SecretId'
t.oss.qcloudSecretKey = 'SecretKey'
t.oss.qcloudSecretKeyTips = '腾讯云SecretKey'
t.oss.qcloudBucketName = 'BucketName'
t.oss.qcloudBucketNameTips = '腾讯云BucketName'
t.oss.qcloudRegion = '所属地区'
t.oss.qcloudRegionTips = '请选择'
t.oss.qcloudRegionBeijing1 = '北京一区（华北）'
t.oss.qcloudRegionBeijing = '北京'
t.oss.qcloudRegionShanghai = '上海（华东）'
t.oss.qcloudRegionGuangzhou = '广州（华南）'
t.oss.qcloudRegionChengdu = '成都（西南）'
t.oss.qcloudRegionChongqing = '重庆'
t.oss.qcloudRegionSingapore = '新加坡'
t.oss.qcloudRegionHongkong = '香港'
t.oss.qcloudRegionToronto = '多伦多'
t.oss.qcloudRegionFrankfurt = '法兰克福'
t.oss.localDomain = '域名'
t.oss.localDomainTips = '绑定的域名'
t.oss.fastdfsDomain = '域名'
t.oss.fastdfsDomainTips = '绑定的域名'
t.oss.localPrefix = '路径前缀'
t.oss.localPrefixTips = '不设置默认为空'
t.oss.localPath = '存储目录'
t.oss.localPathTips = '如：D:/upload'

t.dept = {}
t.dept.name = '名称'
t.dept.parentName = '上级部门'
t.dept.sort = '排序'
t.dept.parentNameDefault = '一级部门'

t.dict = {}
t.dict.dictName = '名称'
t.dict.dictNameCn = '中文名称'
t.dict.dictNameEn = '英文名称'
t.dict.dictType = '类型'
t.dict.dictValue = '值'
t.dict.sort = '排序'
t.dict.remark = '备注'
t.dict.createTime = '创建时间'
t.dict.dictValue = '字典值'
t.dict.status = '状态'

t.logError = {}
t.logError.module = '模块名称'
t.logError.requestUri = '请求URI'
t.logError.requestMethod = '请求方式'
t.logError.requestParams = '请求参数'
t.logError.ip = '操作IP'
t.logError.userAgent = '用户代理'
t.logError.createDate = '创建时间'
t.logError.errorInfo = '异常信息'

t.logLogin = {}
t.logLogin.creatorName = '用户名'
t.logLogin.status = '状态'
t.logLogin.status0 = '失败'
t.logLogin.status1 = '成功'
t.logLogin.status2 = '账号已锁定'
t.logLogin.operation = '操作类型'
t.logLogin.operation0 = '登录'
t.logLogin.operation1 = '退出'
t.logLogin.ip = '操作IP'
t.logLogin.userAgent = 'User-Agent'
t.logLogin.createDate = '创建时间'

t.logOperation = {}
t.logOperation.module = '模块名称'
t.logOperation.status = '状态'
t.logOperation.status0 = '失败'
t.logOperation.status1 = '成功'
t.logOperation.creatorName = '用户名'
t.logOperation.operation = '用户操作'
t.logOperation.requestUri = '请求URI'
t.logOperation.requestMethod = '请求方式'
t.logOperation.requestParams = '请求参数'
t.logOperation.requestTime = '请求时长'
t.logOperation.ip = '操作IP'
t.logOperation.userAgent = 'User-Agent'
t.logOperation.createDate = '创建时间'

t.menu = {}
t.menu.nameCn = '中文名称'
t.menu.nameEn = '英文名称'
t.menu.sysCode = '子系统'
t.menu.name = '名称'
t.menu.icon = '图标'
t.menu.type = '类型'
t.menu.type0 = '目录'
t.menu.type1 = '菜单'
t.menu.type2 = '按钮'
t.menu.sort = '排序'
t.menu.hide = '是否显示'
t.menu.orderNum = '排序'
t.menu.show = '显示'
t.menu.hidden = '不显示'
t.menu.url = '路由'
t.menu.perms = '授权标识'
t.menu.permissions = '接口地址'
t.menu.permissionsTips = '如: sys/menu'
t.menu.parentName = '上级菜单'
t.menu.parentNameDefault = '一级菜单'
t.menu.resource = '授权资源'
t.menu.resourceUrl = '资源URL'
t.menu.resourceMethod = '请求方式'
t.menu.resourceAddItem = '添加一项'

t.params = {}
t.params.paramCode = '编码'
t.params.paramValue = '值'
t.params.remark = '备注'

t.role = {}
t.role.roleName = '角色名称'
t.role.roleOrgScope = '数据范围分类'
t.role.authType = '角色分类'
t.role.createUser = '创建人'
t.role.createTime = '创建时间'
t.role.menuList = '权限授权'
t.role.deptList = '流程授权'
t.role.companyDistributor = '数据范围'
t.role.distributionUser = '分配用户'
t.role.notNull = '分配需要至少选择一条数据'
t.role.roleCode = '角色编码'
t.role.defaultFlag = '是否内置角色'
t.role.organizationExport = '角色导出'

t.user = {}
t.user.username = '用户名'
t.user.deptName = '所属部门'
t.user.email = '邮箱'
t.user.mobile = '手机'
t.user.status = '状态'
t.user.status0 = '停用'
t.user.status1 = '正常'
t.user.createDate = '创建时间'
t.user.password = '密码'
t.user.comfirmPassword = '确认密码'
t.user.realName = '真实姓名'
t.user.gender = '性别'
t.user.gender0 = '男'
t.user.gender1 = '女'
t.user.gender2 = '保密'
t.user.roleIdList = '角色配置'
t.user.validate = {}
t.user.validate.comfirmPassword = '确认密码与密码输入不一致'
t.user.customerType = '用户类型'
t.user.grouping = '分组'
t.user.role = '角色'
t.user.posit = '职位'
t.user.position = '主要职位'
t.user.positionSelect = '请选择主要职位'
t.user.userName = '用户名'
t.user.userEmail = '邮箱'
t.user.companyDistributor = '公司名称'
t.user.incumbency = '在职状态'
t.user.brand = '品牌'
t.user.dotType = '网点类型'
t.user.leaveDate = '离职日期'
t.user.leaveWhy = '员工离职原因'
t.user.accessionDate = '加入当前公司日期'
t.user.accessionDateSelect = '请选择加入当前公司日期'
t.user.citywhere = '所在城市'
t.user.phonenumber = '手机'
t.user.query = '查询'
t.user.accountMerging = '账号合并'
t.user.newlyBuild = '新增'
t.user.export = '导出'
t.user.batchImport = '批量导入'
t.user.operation = '操作'
t.user.tenants = '分配租户'
t.user.tenantsOf = '所属租户'
//租户登录
t.user.tenantLogin = 'It is detected that you have associated multiple enterprises,please select access '
t.user.tenantTo = 'account '
t.user.tenantSelect = '请选择进入账号'
t.user.onTheJob = '在职'
t.user.absenceFromDuty = '在职'
t.user.currentversion = '当前版本'
t.user.essentialInformation = '基本信息'
t.user.inputContent = '请输入内容'
t.user.inputMail = '请输入邮箱'
t.user.mainJobPH = '请选择主要职位'
t.user.partOrgPH = '请选择兼职网点'
t.user.partJobPH = '请选择兼职职位'
t.user.partJob = '兼职职位'
t.user.chineseName = '中文名'
t.user.idcard = '身份证'
t.user.passport = '护照'
t.user.dateofbirth = '出生日期'
t.user.userID = '用户ID'
t.user.userCardNo = '员工号'
t.user.education = '最高学历'
t.user.accessionDate2 = '加入网点日期'
t.user.buildmen = '创建人'
t.user.lastlogintime = '最后登录时间'
t.user.lastPassword = '最后修改密码时间'
t.user.null = '无'
t.user.setting = '设置'
t.user.accountinformation = '账号信息'
t.user.permissionclassification = '权限分类'
t.user.status10 = '是否允许登录'
t.user.firstname = '姓的拼音'
t.user.lastname = '名的拼音'
t.user.name = '姓名'
t.user.passportIdcard = '证件编号'
t.user.passportIdcardPlaceholder = '请输入证件编号'
t.user.reset = '重置'
t.user.more = '展开显示更多'
t.user.hide = '隐藏'
t.user.move = '在职'
t.user.unmove = '离职'
t.user.yes = '是'
t.user.no = '否'
t.user.input = '请输入'
t.user.courseName = '课程名称'
t.user.select = '请选择'
t.user.selectBirthday = '请选择出生日期'
t.user.selectSex = '请选择性别'
t.user.firstNamePlaceholder = '请输入姓的拼音'
t.user.lastNamePlaceholder = '请输入名的拼音'
t.user.userNamePlaceholder = '请输入姓名'
t.user.userImg = '修改头像'
t.user.educationCodePlaceholder = '请选择最高学历'
t.user.orgTypePlaceholder = '请选择组织类型'
t.user.authTypePlaceholder = '请选择权限分类'
t.user.orgPlaceholder = '请选择所属公司'
t.user.deptPlaceholder = '请输入部门'
t.user.positionPlaceholder = '请选择职位'
t.user.dealerPlaceholder = '请选择预签约经销商'
t.user.graduateStatusPlaceholder = '请选择在校状态'
t.user.enterSchoolPlaceholder = '请选择入校日期'
t.user.outletIDPlaceholder = '请选择所属经销商网点'
t.user.business = '业务信息'
t.user.BMWtime = '宝龄（年）'
t.user.GWMinformation = '宝马集团信息'
t.user.outletGroupinformation = '经销商集团信息'
t.user.dealerGroupInformation = '经销商集团信息'
t.user.GWMcompany = '所属公司'
t.user.orgAbbreviation = '所属公司简称'
t.user.orgName = '所属公司全称'
t.user.department = '部门'
t.user.departmentInput = '请输入部门'
t.user.partner = '所属公司信息'
t.user.dealer = '经销商信息'
t.user.brandCodes = '所属品牌'
t.user.bbaNo = '所属BBA No'
t.user.nscno = '所属NSC No'
t.user.outlet = '所属经销商网点'
t.user.outletNew = '所属经销商网点不得为空'
t.user.outlet1 = '兼职1所属网点'
t.user.outlet2 = '兼职2所属网点'
t.user.outlet3 = '兼职3所属网点'
t.user.outlet4 = '兼职4所属网点'
t.user.outlet5 = '兼职5所属网点'
t.user.outlet1Select = '请选择兼职1所属网点'
t.user.outlet2Select = '请选择兼职2所属网点'
t.user.outlet3Select = '请选择兼职3所属网点'
t.user.outlet4Select = '请选择兼职4所属网点'
t.user.outlet5Select = '请选择兼职5所属网点'
t.user.joinjobdate = '加入该职位日期'
t.user.leavejobdate = '离开该职位日期'
t.user.parttimejob1 = '兼职职位1'
t.user.parttimejob1Select = '请选择兼职职位1'
t.user.joinparttimejob1 = '加入兼职职位1日期'
t.user.joinparttimejob1errow = '加入兼职职位1日期不能为空'
t.user.joinparttimejob2errow = '加入兼职职位2日期不能为空'
t.user.joinparttimejob3errow = '加入兼职职位3日期不能为空'
t.user.joinparttimejob4errow = '加入兼职职位4日期不能为空'
t.user.leaveparttimejob1 = '离开兼职职位1日期'
t.user.parttimejob2 = '兼职职位2'
t.user.parttimejob2Select = '请选择兼职职位2'
t.user.joinparttimejob2 = '加入兼职职位2日期'
t.user.leaveparttimejob2 = '离开兼职职位2日期'
t.user.parttimejob3 = '兼职职位3'
t.user.parttimejob3Select = '请选择兼职职位3'
t.user.joinparttimejob3 = '加入兼职职位3日期'
t.user.leaveparttimejob3 = '离开兼职职位3日期'
t.user.parttimejob4 = '兼职职位4'
t.user.parttimejob4Select = '请选择兼职职位4'
t.user.joinparttimejob4 = '加入兼职职位4日期'
t.user.leaveparttimejob4 = '离开兼职职位4日期'
t.user.parttimejob5 = '兼职职位5'
t.user.parttimejob5Select = '请选择兼职职位5'
t.user.joinparttimejob5 = '加入兼职职位5日期'
t.user.leaveparttimejob5 = '离开兼职职位5日期'
t.user.chiefpostManager = '主要职位直线经理'
t.user.chiefpostManager1 = '兼职职位1直线经理'
t.user.chiefpostManager2 = '兼职职位2直线经理'
t.user.chiefpostManager3 = '兼职职位3直线经理'
t.user.chiefpostManager4 = '兼职职位4直线经理'
t.user.beststudent = 'BEST学员信息'
t.user.joinschool = '入校日期'
t.user.leaveschool = '离校日期'
t.user.leaveschoolSelect = '离校时间'
t.user.major = '专业'
t.user.graduation = '在校状态'
t.user.trainer = '培训师信息'
t.user.trainerrole = '培训师信息'
t.user.trainerall = '培训师分类'
t.user.trainerteam = '培训师团队分类（一级）'
t.user.enddateftrialtalk = '试讲结束日期'
t.user.effectivedate = '生效日期'
t.user.trainingobjectives = '年度培训目标'
t.user.TAlevl = 'TA级别'
t.user.teacherlvel = '培训师级别'
t.user.save = '保存'
t.user.back = '返回'
t.user.agreeconceal = '是否同意收集隐私'
t.user.trainingschool = '所属培训学校'
t.user.reservedDistributor = '预签约经销商'
t.user.joininDistributor = '是否同意加入人才库'
t.user.Distributor = '是否推荐人才'
t.user.numberbankaccount = 'BEST候选人账号'
t.user.numberbankaccountSelect = '请选择BEST候选人账号'
t.user.trainerrole = '培训师角色'
t.user.contractnumber = '合同号'
t.user.leavejoinschooldate = '入校时间不能晚于离校时间'
t.user.leavejoinschooldate1 = '离校时间不能早于入校时间'
t.user.leaveSmalldate = '入职时间不得小于离职日期'
t.user.leaveSmalldate1 = '离职日期不得小于入职时间'
t.user.leave30date = '离职时间不得超过当前30天'
t.user.verificationfirstname = '姓的拼音不能为空'
t.user.verificationlastname = '名的拼音不能为空'
t.user.verificationname = '姓名不能为空'
t.user.verificationemail = '邮箱不能为空'
t.user.verificatioCompany = '公司不能为空'
t.user.verificationtelphone = '手机不能为空'
t.user.verificationtelphoneid = '请输入手机'
t.user.verificationjobcode = '入职时间不能为空'
t.user.verificationcompany = '公司不能为空'
t.user.verificationidcard = '证件编号不能为空'
t.user.validateMobileCaptcha = '手机和手机验证码不能为空'
t.user.validateEmailCaptcha = '邮箱和邮箱验证码不能为空'
t.user.checkdate = '选择日期'
t.user.checkadmin = '选择用户'
t.user.history = '历史版本'
t.user.onebyone = '不允许超明年1月1日'
t.user.monthOnebyone = '不能早于当前月份1号，且不能晚于今天'
t.user.nowTimeLater = '已开业网点开业时间不允许晚于当前日期'
t.user.nowTimeEarlier = '筹备中网点开业时间不允许早于等于当前日期'
t.user.telephone = '手机不可为空'
t.user.telephoneerro = '请输入正确的手机'
t.user.telphone615 = '请输入6到15位的手机'
t.user.verificationemailerrow = '请输入正确的邮箱'
t.user.verificationidcarderrow = '请输入有效的证件编号'
t.user.verificationbirthdayerrow = '年龄应该大于等于15周岁，小于等于70周岁'
t.user.verificationbirthday = '出生日期不能为空'
t.user.verificationsexCode = '性别不能为空'
t.user.verificationpassporterrow = '请输入正确的护照号'
t.user.verificationlength = '长度1到20个字数之间'
t.user.verificationlengthTwo = '长度1到40个字数之间'
t.user.verificationlengthThree = '长度1到80个字数之间'
t.user.verificationhistoryLeaveDate = '入职日期不得早于历史离职日期[{handle}]'
t.user.verificationparttime = '兼职不能重复'
t.user.verificationparttimeJobCode = '兼职不能与主职重复'
t.user.verificationparttimeJobCodeSame = '变更后的职位与网点不可与变更前的相同'
t.user.verificationparttimeJobCodeOutletSame = '请调整兼职职位1和兼职职位2顺序'
t.user.verificationparttimeJobCodeOne = '请填写兼职职位1'
t.user.generateAccount = '生成账号'
t.user.downloadtemplate = '下载模板/批量导入'
t.user.batchdeletion = '批量删除'
t.user.userpost = '岗位'
t.user.userImporttemplate = '用户导入模板'
t.user.sure = '确定对'
t.user.verificationagreePolicy = '请选择是否同意收集隐私'
t.user.addjobcode = '先填写职位'
t.user.verificationorgtype = '组织类型不能为空'
t.user.verificationauthtype = '权限分类不能为空'
t.user.verificationgraduate = '在校状态不能为空'
t.user.delet = '确定删除？'
t.user.doingcounts = '生成账号状态'
t.user.doing = '已生成'
t.user.nodoing = '生成失败'
t.user.nodoing1 = '未生成'
t.user.placeselect = '请选择需要生成的账号'
t.user.idtype = '证件类型'
t.user.idtypePlaceholder = '请选择证件类型'
t.user.mobilePlaceholder = '请输入手机'
t.user.joblevl = '职级'
t.user.jobyear = '当前岗龄（天）'
t.user.showBrand = '品牌'
t.user.showCompanyName = '公司'
t.user.showNetworkType = '网点类型'
t.user.parttimejobaddnum = '兼职最多4个'
t.user.parttimejobcutnum = '兼职最少1个'
t.user.verificationfirstname1 = '不能含有空格'
t.user.verificationUser = '账号不能含有空格'
t.user.verificationfirstname2 = '只允许输入字母和 _ - ·'
t.user.verificationfirstname3 = '只允许输入汉字，字母和 _ - ·'
t.user.deletparttimejob = '确定删除兼职？'
t.user.add = '添加'
t.user.delete = '删除'
t.user.popTitle = '请选择要显示的列'
t.user.userExport = '用户导出'
t.user.positionNow = '当前职位'
t.user.transferpositiondate = '调转职位日期'
t.user.transferposition = '调转职位'
t.user.transferparttimejob1 = '调转职位1'
t.user.transferparttimejob2 = '调转职位2'
t.user.transferparttimejob3 = '调转职位3'
t.user.transferparttimejob4 = '调转职位4'
t.user.transferparttimejobtime1 = '调转职位1日期'
t.user.transferparttimejobtime2 = '调转职位2日期'
t.user.transferparttimejobtime3 = '调转职位3日期'
t.user.transferparttimejobtime4 = '调转职位4日期'
t.user.leaveOffice = '离职'
t.user.orgTypeCode = '经销商代码'
t.user.transfer = '转岗'
t.user.leaveOffice = '离职'
t.user.downloadResume = '下载简历'
t.user.findResume = '查看简历'
t.user.assignTenant = '分配租户'
t.user.trainingRecord = '培训记录'
t.user.presentation = '温馨提示：选择是，为该员工点亮小星星，让更多的HR关注他/她。'
t.user.affiliatedOrganization = '所属组织'
t.user.outletJoinDate = '加入经销商网点日期'
t.user.registration = '入职状态'
t.user.beforejobcode = '请填写上一个兼职'
t.user.registrationApprovaStatus = '该用户未通过注册审批，不可操作'
t.user.outletType = '网点类型'
t.user.hasRegist50 = '该用户已注册并且“在职”，请勿重复注册。'
t.user.hasRegist = '该证件号已存在，待审批中。'
t.user.leaveDateError = '不能早于上一个版本的离职日期[{handle}]'
t.user.hasLeave = '该用户已存，是否再次入职'
t.user.hasNoPartTime = '该网点下没有职位，请重新选择'
t.user.noidType = '证件类型不能为空'
t.user.notelephone = '手机不能为空'
t.user.usereducationCode = '最高学历不能为空'
t.user.userorgJoinDate = '加入公司日期不能为空'
t.user.userleaveDate = '离开公司日期不能为空'
t.user.userRoleId = '角色不能为空'
t.user.userJobCode = '主要职位不能为空'
t.user.noIdcard = '证件号不能为空'
t.user.parttimeNotNull = '兼职[{handle}]信息不完善'
t.user.headUrlNotNull = '用户头像不能为空'
t.user.selectauth = '请先选择权限分类'
t.user.affiliatedDeale = '所属经销商'
t.user.validatorJoinSchool = '入校时间不能为空'
t.user.validatordealerShipId = '预留签约经销商不能为空'
t.user.validatortalentBankFlag = '是否同意人才入库不能为空'
t.user.validatorofficialAccountFlag = 'BEST候选人账号不能为空'
t.user.validatormajorCode = '专业不能为空'
t.user.validatorDept = '部门不能为空'
t.user.partTimeOutletOne = '兼职网点1'
t.user.partTimeOutletTwo = '兼职网点2'
t.user.affiliatedGroup = '所属宝马集团'
t.user.affiliatedPartner = '所属合作伙伴'
t.user.affiliatedCollege = '所属合作院校'
t.user.affiliatedDealerGroup = '所属经销商集团'
t.user.dimissionMessage = '离职信息'
t.user.transferBefore = '转岗前'
t.user.transferAfter = '转岗后'
t.user.transferAfterParttimeJob1 = '转岗后兼职一不能为空'
t.user.transferAfterParttimeJob2 = '转岗后兼职二不能为空'
t.user.transferAfterParttimeJob3 = '转岗后兼职三不能为空'
t.user.transferAfterParttimeJob4 = '转岗后兼职四不能为空'
t.user.transferAfterParttimeJob5 = '转岗后兼职五不能为空'
t.user.validatortheme = '邮件主题不能为空'
t.user.validatorcontent = '邮件内容不能为空'
t.user.validatorsevendimissionDate1 = '可选离职日期为离职发起日期起（'
t.user.validatorsevendimissionDate2 = '）天内，且不能早于今天'
t.user.validatorsevendimissionDate3 = '-'
t.user.validatorDimissionReason = '离职原因不能为空'
t.user.validatorDimissionWhereAbout = '离职去向不能为空'
t.user.validatorDimissionType = '离职方式不能为空'
t.user.validatorDimissionReasonContent = '其他离职原因不能为空'
t.user.validatorDimissionReasonContentWhereAbout = '其他离职去向原因不能为空'
t.user.validatorDimissionReasonContentNewEnergy = '新能源公司不能为空'
t.user.validatordimissionDate = '离职日期不能为空'
t.user.userLeaveDoing = '离职申请中'
t.user.emergencyContact = '紧急联系人及联系方式'
t.user.emergencyContactInput = '请输入紧急联系人及联系方式'
t.user.privacyFileUrl = '隐私协议'
t.user.transferErrorMessage = '入职当天不能进行转岗操作'
t.user.dissionErrorMessage = '入职当天不能进行离职操作'
t.user.headDate1 = '当前版本有效期从 '
t.user.headDate2 = ' 到 '
t.user.deactivatedTime = '账号禁用日期'
t.user.deactivatedReason = '禁用原因'
t.user.deactivatedReasonInput = '请输入账号禁用原因'
t.user.idcardUploadFlag = '身份证照片已上传'
t.user.lastFaceVerifyTime = '最后一次面部信息识别时间'
t.user.lastRemindTime = '最后一次提醒时间'
t.user.authApply = '变更权限'
t.user.authApplyErrorMessage = '入职当天不能变更权限'
t.user.authApplyDownloadFileMessage = '文件开始下载，请稍等...'
t.user.noticeFaceCheck = '请管理员提醒用户在收到注册成功通知的当日，须登录悦学苑APP端并完成身份及面部识别验证'
t.user.assignTenantTitle = '分配租户'
t.user.userCodeLabel = '用户ID'
t.user.userNameLabel = '用户姓名'
t.user.ownTenantLbael = '所属租户'
t.user.tenantPlaceholder = '请选择租户'


// 组织管理
t.organization = {}
t.organization.orgType = '组织类型'
t.organization.status = '状态'
t.organization.abbreviation = '简称'
t.organization.name = '全称'
t.organization.abbreviationZh = '中文简称'
t.organization.abbreviationEn = '英文简称'
t.organization.nameZh = '中文全称'
t.organization.nameEn = '英文全称'
t.organization.nameZhAndNameEn = '中文名称/英文名称'
t.organization.address = '地址'
t.organization.zipCode = '邮编'
t.organization.mobile = '手机'
t.organization.contacter = '联系人'
t.organization.contacterMobile = '办公电话'
t.organization.fax = '传真'
t.organization.joinDateBmw = '加入宝马时间'
t.organization.orgCode = '组织编号'
t.organization.comType = '组织类型'
t.organization.networkType = '网点类型'
t.organization.affiliatedOrganization = '所属组织'
t.organization.cityIds = '所在城市'
t.organization.openDate = '开业时间'
t.organization.openDateStart = '开业时间起'
t.organization.openDateEnd = '开业时间止'
t.organization.nscNo = 'NSC No.(CBU)'
t.organization.bbaNo = 'BBA No.(CKD)'
t.organization.nscCbuNo = 'NSC No.(CBU)'
t.organization.bbaCkdNo = 'BBA No.(CKD)'
t.organization.brandCodes = '品牌'
t.organization.preNscNo = 'Pre NSC No'
t.organization.preBbaNo = 'Pre BBA No'
t.organization.preRegisterNameZh = '预登记中文名'
t.organization.preRegisterNameEn = '预登记英文名'
t.organization.mainNetworkFlag = '是否主要网点'
t.organization.mainNetworkId = '关联主要网点'
t.organization.motherShopFlag = '是否经销商母店'
t.organization.motherShopId = '经销商母店'
t.organization.dealerShipType = '经销商类型'
t.organization.groupCode = '集团编号'
t.organization.keyword = '请输入关键词'
t.organization.contractList = '合同列表'
t.organization.contractCode = '合同号'
t.organization.joinDateBmw = '服务宝马网络开始日期'
t.organization.endDate = '结束日期'
t.organization.teacherLevel = '教师等级'
t.organization.serviceProject = '服务项目'
t.organization.projectType = '项目类型'
t.organization.cityLevel = '城市级别'
t.organization.price = '价格'
t.organization.addRow = '新增一行'
t.organization.venderNo = '供应商代码'
t.organization.parentDealerGroupId = '所属集团'
t.organization.dealerShipStatus = '经销商状态'
t.organization.dmsCode = 'DMS代码'
t.organization.parentDealeId = '所属经销商'
t.organization.salesPartnerId = 'Sales Partner ID'
t.organization.salesPartnerIdPlaceholder = '如11101-02'
t.organization.orgCodeMessage = '自动生成'
t.organization.orgCodeBring = '自动带入'
t.organization.networkStatus = '网点状态'
t.organization.dealerSize = '经销商规模'
t.organization.tagName = '标签'
t.organization.save = '保存'
t.organization.back = '返回'
t.organization.startData = '开始日期'
t.organization.endData = '结束日期'
t.organization.officeMail = '办公邮箱'
t.organization.dealerNumber = '经销商数'
t.organization.outletNumber = '经销商网点数'
t.organization.nscNoOwn = '所属NSC No'
t.organization.brandCodesOwn = '所属品牌'
t.organization.company = '公司'
t.organization.companyMessage = '简称/全称/NSC/BBA'
t.organization.businessScope = '经营范围'

t.organization.basicInformation = '基本信息'
t.organization.orgType10 = '宝马集团'
t.organization.orgType2030 = '合作伙伴/合作院校'
t.organization.orgType40 = '经销商集团'
t.organization.orgType50 = '经销商'
t.organization.orgType60 = '网点'
t.organization.organizationExport = '公司导出'
t.organization.regionSelect = '请选择到具体的省市'
t.organization.area = '所在区域'
t.organization.orgName = "组织名称"

// 离职
t.dimission = {}
t.dimission.userCode = '用户名'
t.dimission.name = '姓名'
t.dimission.userName = '员工姓名'
t.dimission.dimissionDate = '离职日期'
t.dimission.dimissionReason = '离职原因'
t.dimission.dimissionWhereAbout = '离职去向'
t.dimission.dimissionType = '离职方式'
t.dimission.dimissionReasonHR = 'HR离职原因'
t.dimission.mobile = '联系电话'
t.dimission.emailAddress = 'Email地址'
t.dimission.wechatNo = '微信号'
t.dimission.dimissionStatus = '处理状态'
t.dimission.jobCode = '职位'
t.dimission.userType = '用户类型'
t.dimission.gender = '用户类型'
t.dimission.dimissionId = '序号'
t.dimission.sexCode = '性别'
t.dimission.workingYears = '工作年限'
t.dimission.bmwSeniority = '宝龄（年）'
t.dimission.jobCode = '职位'
t.dimission.educationCode = '学历'
t.dimission.orgJoinDate = '加入网点日期'
t.dimission.startData = '开始时间'
t.dimission.endData = '结束时间'
t.dimission.talentBankFlag = '是否加入人才库'
t.dimission.orgName = '公司'
t.dimission.recommendFlag = '是否推荐人才'

// header的登录
t.headerLogin = {}
t.headerLogin.login = '登录'
t.headerLogin.logout = '退出登录'
t.headerLogin.mine = '我的'
t.headerLogin.account = '个人基本信息'
t.headerLogin.resume = '个人简历'

// header的菜单
t.headerMenu = {}
t.headerMenu.main = '首页'
t.headerMenu.information = '资讯'
t.headerMenu.addBEST = '加入BEST'
t.headerMenu.academicHorizon = '学院视界'
t.headerMenu.addBMW = '加入BMW经销商'
t.headerMenu.person = '个人中心'
t.headerMenu.manage = '通用管理'
t.headerMenu.login = '登录'
t.headerMenu.register = '注册'
t.headerMenu.h51 = '精英之路  （H5)'
t.headerMenu.h52 = '欢迎加入BMW （H5）'
t.headerMenu.h521 = '校招'
t.headerMenu.h522 = '社招'
t.headerMenu.h53 = '（H5）预备'
t.headerMenu.h54 = '（培训学院介绍（H5）'
t.headerMenu.xiaobao = 'xiaobao'
t.headerMenu.findDetail = '查看详情'

// protal数据
t.protal = {}
t.protal.study = '课程学习'
t.protal.alreadyStudy = '已学课程'
t.protal.expertCourse = '专家课程'
t.protal.Alreadystudied = '已学习'
t.protal.curriculum = '个课程'
t.protal.Facetofacecourses = '面授课程'
t.protal.CapacityExpansion = '能力拓展'
t.protal.information = '资讯信息'
t.protal.newinformation = '最新资讯'
t.protal.oldinformation = '以往资讯'
t.protal.learn = '学习'
t.protal.Examination = '考试'
t.protal.Authentication = '认证'
t.protal.lesson = '课程'
t.protal.onlinelesson = '线上课程'
t.protal.CapabilityAssessment = '能力评估'
t.protal.PersonalCapabilityAssessment = '个人能力评估'
t.protal.EvaluationFeedback = '评估反馈'
t.protal.DevelopmentPlan = '评估计划'
t.protal.data = '资料'
t.protal.newdata = '最新资料'
t.protal.hotdata = '热门资料'
t.protal.alldata = '全部资料'
t.protal.my = '我的'
t.protal.Careerpath = '职业路径'
t.protal.Annualreport = '年度报告'
t.protal.AccountSettings = '账户设置'
t.protal.resume = '简历'
t.protal.Myagent = '我的待办'
t.protal.Messagecenter = '消息中心'
t.protal.Mymission = '我的任务'
t.protal.Mycollection = '我的收藏'
t.protal.Myinterest = '我的兴趣'
t.protal.Mypoints = '我的积分'
t.protal.Administration = '管理'
t.protal.Talentmanagement = '管理'
t.protal.Studymanagement = '学习管理'
t.protal.Reportform = '报表'
t.protal.FacetofaceTeachingManagement = '面授课程管理'
t.protal.AuthenticationManagement = '认证'
t.protal.AnsweringQuestion = '答疑与评价管理'
t.protal.findDetail = '了解详情'
t.protal.addMenuTitle = '添加快捷菜单'
t.protal.addMenuLabel = '名称'
t.protal.addMenuSave = '保存'
t.protal.quickMenuError = '只能收藏左侧菜单页面'

// 门户login
t.protaLogin = {}
t.protaLogin.loginBtn = '登录'
t.protaLogin.registerBtn = '注册'
t.protaLogin.bigTitle = '新平台'
t.protaLogin.smallTitle = 'NEW PLATFORM'
t.protaLogin.accountLogin = '密码登录'
t.protaLogin.phoneLogin = '动态码登录'
t.protaLogin.username = '用户名'
t.protaLogin.password = '密码'
t.protaLogin.captcha = '验证码'
t.protaLogin.captchaD = '动态码'
t.protaLogin.findPassword = '忘记密码'
t.protaLogin.agree = '我同意xxxx的内容'
t.protaLogin.nameLabel = '用户ID/邮箱'
t.protaLogin.captchaLabel = '验证码'
t.protaLogin.passwordLabel = '密码'
t.protaLogin.phoneLabel = '手机'
t.protaLogin.getCaptcha = '获取验证码'
t.protaLogin.getCaptchaD = '获取验证码'
t.protaLogin.getCaptchaTip = '秒后重新获取'
t.protaLogin.mobileVerified = '请输入正确的手机'
t.protaLogin.emailVerified = '请输入正确的邮箱号'
t.protaLogin.captchaVerified = '请输入验证码'
t.protaLogin.modifyPassword = '修改密码'
t.protaLogin.continue = '继续'
t.protaLogin.upcoming = '待办任务'
t.protaLogin.checking = '验证'
t.protaLogin.phoneCheck = '手机验证'
t.protaLogin.mailCheck = '邮箱验证'
t.protaLogin.mail = '邮箱'
t.protaLogin.mailExample = '请输入邮箱'
t.protaLogin.mobileExample = '请输入手机'
t.protaLogin.captchaExample = '请输入验证码'
t.protaLogin.captchaSucc = '验证码已发送3分钟内有效，但目前仅支持中国大陆地区手机的短信发送功能'
t.protaLogin.captchaEmailSucc = '验证码已发送到您的邮箱,3分钟内有效'
t.protaLogin.notify = '消息'

// 门户注册
t.protaRegister = {}
t.protaRegister.title = '游客注册'
t.protaRegister.nameLabel = '姓名'
t.protaRegister.account = '员工号'
t.protaRegister.userId = '用户 ID'
t.protaRegister.idcard = '证件编号'
t.protaRegister.orgName = '公司名称'
t.protaRegister.namePlace = '请输入用户名'
t.protaRegister.nameCnLabel = '姓名'
t.protaRegister.nameCnPlace = '请输入姓名'
t.protaRegister.mailLabel = '邮箱'
t.protaRegister.mailPlace = '请输入邮箱地址'
t.protaRegister.phoneLabel = '手机'
t.protaRegister.phonePlace = '请输入手机'
t.protaRegister.captchaLabel = '验证码'
t.protaRegister.captchaPlace = '验证码'
t.protaRegister.captchaBtn = '获取验证码'
t.protaRegister.passwordLabel = '密码'
t.protaRegister.passwordPlace = '请输入密码'
t.protaRegister.passwordSureLabel = '密码确认'
t.protaRegister.passwordSurePlace = '请再次输入密码'
t.protaRegister.agree = '同意'
t.protaRegister.agreement = '宝马个人信息保护政策'
t.protaRegister.agreementSecond = '跨境传输个人信息说明'
t.protaRegister.messageProtection = '个人信息共享说明'
t.protaRegister.registerBtn = '注册'
t.protaRegister.message = '新密码不能与旧密码重复'
t.protaRegister.revokePrivacy = '撤销隐私协议'
t.protaRegister.revokeBtn = '撤销'
t.protaRegister.revokeTip = '即将执行撤销隐私协议的操作，该操作不可逆，请牢记您的证件编号、手机、邮箱、生日，以免需要恢复您的账号信息时无法执行'
t.protaRegister.idcardNull = '证件编号不能为空'

//

// 忘记密码
t.protaForgetPassword = {}
t.protaForgetPassword.title = '忘记密码'
t.protaForgetPassword.phoneLabel = '手机/邮箱'
t.protaForgetPassword.phonePlace = '手机/邮箱'
t.protaForgetPassword.captchaLabel = '验证码'
t.protaForgetPassword.captchaPlace = '验证码'
t.protaForgetPassword.captchaBtn = '获取验证码'
t.protaForgetPassword.passwordLabel = '新密码'
t.protaForgetPassword.newPasswordLabel = '请输入新密码'
t.protaForgetPassword.oldPasswordLabel1 = '确认新密码与新密码不相同'
t.protaForgetPassword.newPasswordLabel1 = '新密码不能为空'
t.protaForgetPassword.enterNewPasswordLabel1 = '确认新密码不能为空'
t.protaForgetPassword.passwordPlace = '请输入新密码'
t.protaForgetPassword.passwordSureLabel = '确认新密码'
t.protaForgetPassword.passwordSurePlace = '请再次输入新密码'
t.protaForgetPassword.sureBtn = '完成'
t.protaForgetPassword.mobileOrEmail = '请输入正确的手机码或者邮箱'
t.protaForgetPassword.mailTODO = '邮箱找回密码正在开发中……'
t.protaForgetPassword.oldPassword = '旧密码'
t.protaForgetPassword.oldPassword1 = '旧密码不能为空'
t.protaForgetPassword.inputOldPassword = '请输入旧密码'

// position数据
t.position = {}
t.position.positionCode = '职位代码'
t.position.positionCodeMessage = '001'
t.position.agCodeMessage = 'MM02'
t.position.positionName = '职位名称'
t.position.positionNameMessage = '销售顾问'
t.position.positionNameCn = '职位中文名称'
t.position.positionNameEn = '职位英文名称'
t.position.brandCode = '职位品牌'
t.position.singlePosition = '单店单岗'
t.position.partTimeJobFlag = '可设为兼职职位'
t.position.orgType = '组织类型'
t.position.positionType = '职位分类'
t.position.positionGroupType = '职位团队分类'
t.position.produceFlag = '职位属性'
t.position.customerFlag = '面向客户职位'
t.position.certificationIds = '认证分类'
t.position.keyPositionCode = 'AG 关键职位代码'
t.position.status = '状态'
t.position.allowPartJobs = '可允许主要职位'
t.position.keyPositionFlag = '关键岗'
t.position.candidateFlag = '是否候选人职位'
t.position.taApprovalFlag = '是否TA审批'
t.position.positionDesc = '职位描述'
t.position.positionDescCn = '中文职位描述'
t.position.positionDescEn = '英文文职位描述'
t.position.completeResumeFlag = '需完善简历'
t.position.organizationExport = '职位导出'
t.position.evaluateFlag = '是否需要能力评估'
t.position.areaAuditFlag = '是否区域经理审批'
t.position.relevantCandidateJobcode = '对应候选人职位'
t.position.allowAdminFlag = '是否允许设置为管理员职位'
//t.position.transferConfirm ='转岗操作会影响已报名课程的费用结算和岗位验证，特别是上市培训。建议完成所有面授课程后，再进行转岗操作。请确认是否继续转岗？'
t.position.transferConfirm = '建议完成所有面授课程后，再进行转岗操作。转岗操作会影响已报名课程的费用结算和岗位验证，特别是上市培训。请确认是否继续转岗？'
// person
t.protaPerson = {}
t.protaPerson.todo = '待办事宜'
t.protaPerson.enrollApprove = '报名审批'
t.protaPerson.knowledgeApprove = '知识审批'
t.protaPerson.JobApprove = '作业批改'
t.protaPerson.paperApprove = '试卷批改'
t.protaPerson.enrollExam = '报名考试'
t.protaPerson.courseStudy = '课程学习'
t.protaPerson.task = '任务'
t.protaPerson.medal = '勋章'
t.protaPerson.other = '其他'
t.protaPerson.trainingRecord = '培训记录'
t.protaPerson.findDetail = '查看详情'
t.protaPerson.growthPath = '成长路径'

t.address = {}
t.address.placeholder = '请选择省份'

// 共同组建
t.common = {}
t.common.openMore = '高级搜索'
t.common.hide = '收起'

// label数据
t.label = {}
t.label.labelName = '标签名称'
t.label.labelFlag = '标签'
t.label.masterData = '业务类型'
t.label.showFlag = '状态'
t.label.addParent = '新增根节点'
t.label.businessNotNull = '业务类型不能为空'

t.common.tagName = '标签类型'
t.common.tagChecked = '业务属性'

// footer
t.footer = {}
t.footer.copyright = '©️ BMW JOY LEARNING 2020 版权所有'
t.footer.schoolPhoneTxt = '客服热线：'
t.footer.schoolPhone = '400-024-7666'
t.footer.schoolMailTxt = '客服邮箱：'
t.footer.schoolMail = 'BMW.CallCenter@bmw-brilliance.cn'
t.footer.contactUsTxt = '联系我们：'
t.footer.contactUs = '北京市朝阳区东三环北路霞光里18号佳程广场'
t.footer.linkTxt = '快速链接：'
t.footer.link = 'BMW 官网'

// region数据
t.region = {}
t.region.regionCode = '编码：'
t.region.parentName = '上级名称：'
t.region.regionName = '名称：'
t.region.regionGrade = '级别：'
t.region.remark = '备注：'
t.region.save = '保存'

// 工作流
t.workflow = {}
t.workflow.workflowId = '关联编号'
t.workflow.previousWorkflowId = '流程名称'
t.workflow.workflowName = '当前节点'
t.workflow.workflowType = '类型'
t.workflow.batchApproval = '批量审批'

t.activiti = {}
t.activiti.missionName = '当前节点'
t.activiti.processName = '流程名称'
// t.activiti.sponsor = ' 用户ID'
t.activiti.sponsor = '发起人'
t.activiti.sponsorOrg = '申请人公司'
t.activiti.orgId = '所属公司'
t.activiti.startingTime = '发起时间'
t.activiti.timeOfArrival = '到达时间'
t.activiti.processInitiationTime = '申请时间'
t.activiti.taskArrivalTime = '任务到达时间'
t.activiti.approval = '审批'
t.activiti.dealWith = '处理'
t.activiti.confirm = '确认'
t.activiti.initiated = '发起的'
t.activiti.currentTaskNode = '当前任务节点'
t.activiti.currentNodeApprover = '当前节点审批人'
t.activiti.taskRetentionTime = '任务滞留时间'
t.activiti.handleTime = '审批时间'
t.activiti.taskInformation = '任务信息'
t.activiti.approver = '审批人'
t.activiti.taskApprovalTime = '任务审批时间'
t.activiti.businessInformation = '业务信息'
t.activiti.approvalHistory = '审批履历'
t.activiti.approvalStatus = '审批状态'
t.activiti.approvalComments = '审批意见'
t.activiti.processingTime = '审批时间'
t.activiti.details = '详情'
t.activiti.viewFlowChart = '查看流程图'
t.activiti.agree = '同意'
t.activiti.disagree = '拒绝'
t.activiti.pleaseEnterApproval = '需要填写审批意见才能点击拒绝按钮'
t.activiti.pleaseEnterApprovalOpinion = '请输入审批意见'
t.activiti.submit = '提交'
t.activiti.withdraw = '撤销'
t.activiti.withdrawSuccess = '撤销成功'
t.activiti.dismissalStatus = '审批状态'
t.activiti.registrationCompleteOver = '审批成功，注册成功'
t.activiti.registrationComplete = '审批成功'
t.activiti.registrationRunning = '审批成功，已提交到下一级审批人'
t.activiti.batchApproval = '批量审批'
t.activiti.batchApprovalMessage = '请选择要批量审批的待办任务'
t.activiti.jobCodeContent = '职位描述：'
t.activiti.singlePosition = '该职位须遵从单店单岗规则，贵店已有其他活动人员任职此职位'
t.activiti.userId = '申请人'
t.activiti.flowChart = '流程图'
t.activiti.jobCodeNum = '职位代码：'
t.activiti.registrationErrorMessage = '该用户已经入职到其他公司，暂无查看权限'
t.activiti.processedPerson = '申请人信息'
t.activiti.processedPersonPlaceholder = '申请人手机，证件编号，用户ID，姓名'
t.activiti.organizationExport = '所有代办导出'

t.activiti.resumeDetails = '简历详情'
t.activiti.resume = '简历：'
t.activiti.report = '报告：'
t.activiti.pleaseCheck = '请确认已勾选确认信息复选框！'
t.activiti.areaManagerConfirmText = '该审批决定须获得区域高级经理确认；如是总经理候选人，则该审批决定须获得区域副总裁确认'

// 区域经理
t.areaManager = {}
t.areaManager.userCode = "区域经理ID"
t.areaManager.userNameCn = "区域经理姓名"
t.areaManager.deptCode = '部门'
t.areaManager.createUserCode = "创建人"
t.areaManager.createTime = "创建时间"
t.areaManager.updateUserCode = "修改人"
t.areaManager.updateTime = "修改时间"
t.areaManager.view = "查看"
t.areaManager.edit = "编辑"
t.areaManager.remove = "删除"
t.areaManager.orgName = "经销商网点"
t.areaManager.active = "活动"
t.areaManager.inactive = "不活动"
t.areaManager.name = "区域经理"
t.areaManager.outletName = '所属公司简称'
t.areaManager.jobName = '职位名称'
t.areaManager.status = '状态'
t.areaManager.modify = '修改'
t.areaManager.export = '评估中心列表导出'
t.areaManager.passportIdcard = '证件号码'
t.areaManager.orgAbbreviation = "公司简称"



// 入离转记录
t.change = {}
t.change.userNamePlaceholder = '用户名/用户ID'
t.change.applicationType = '申请类型'
t.change.approvalStatus = '审批结果'
t.change.applicationDate = '申请时间'
t.change.approvalDate = '审批时间'

// 登录协议
t.agreement = {}
t.agreement.title = '用户登录协议详细说明'
t.agreement.content1 = 'BMW集团'
t.agreement.content2 = '法律声明'
t.agreement.content3 = 'BMW集团感谢您对其产品的关注和您对这个网站的访问。'

t.agreement.content4 = '数据保护'
t.agreement.content5 = 'BMW感谢您关心我们的产品以及浏览我们的网站。当您访问BMW网站的时候可能被要求提供您个人的资料。您可以自由选择是否提供。因为我们的网站遍布全球，访问者也来自不同国家。如果您愿意提供您个人的信息，我们将根据各国的法律把它有效的保存起来。您可以在这些相关网站中查询到您具体的个人信息。'

t.agreement.content6 = '详细个人信息保护法律声明'
t.agreement.content7 = 'Cookies信息'
t.agreement.content8 = '宝马坚持以公开透明的方式收集使用与您相关的数据，本着公开透明的精神，我们在本政策中阐述了宝马使用 Cookie 的方式和情况。宝马网站使用cookie，本Cookie 政策适用于所有宝马网站。'

t.agreement.content9 = '什么是Cookie？'

t.agreement.content10 = 'Cookie 是保存在用户设备上的小文件，用于启用宝马网站功能。例如，我们可通过 Cookie 识别用户设备，保障安全登录宝马网站，以及确定他人是否试图从其他设备登录您的帐号。Cookie 方便用户在宝马网站分享内容，我们也可通过 Cookie 向您推荐相关广告。'

t.agreement.content11 = '宝马在什么情况下插入Cookie？'

t.agreement.content12 = '宝马在其网站中均使用Cookie. 所有打开这些网站的浏览器都将接收来自宝马网站的 Cookie。当您访问含有宝马插件 (如宝马的“分享”到微博、微信或豆瓣等按钮) 或标签的非宝马网站时，我们将在您的浏览器中插入 Cookie。'

t.agreement.content13 = '宝马网站上是否会嵌入来自第三方的Cookie?'

t.agreement.content14 = '在您通过我们的网站访问其他第三方的产品和服务信息时，您的设备可能会接收或访问来自该第三方的cookie和web beacon。这些cookie和web beacon可能会收集与您的设备相关的非个人身份信息，以用于分析用户如何使用该等服务、在您的设备访问相关网页广告内容时向您展示您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookie和web beacon收集和使用该等信息不受本Cookie政策约束，而是受到其自身的Cookie政策约束，请您务必仔细阅读并确认第三方的Cookie政策。我们不对第三方的cookie或web beacon以及相应的信息收集和使用承担法律责任。'

t.agreement.content15 = 'Cookie会被保存多久？'

t.agreement.content16 = 'Cookie将与进程有效时间保持同步。Cookie帮助我们将您识别为既有用户，从而让您再次访问宝马网站或使用我们的服务时更加便捷，无需再次登录。如果您登录并允许使用“记住我”功能，这个Cookie将被宝马读取并保留90天有效。否则，cookie将在您关闭浏览器的同时失效并删除。'

t.agreement.content17 = 'Cookie 的用途是什么？'

t.agreement.content17 = 'Cookie 的用途很广泛，比如在用户使用宝马网站时识别用户身份、保存偏好设置及提供个性化和增强性的用户体验等。用户与宝马网站互动时，Cookie 可提高安全性和速度。另外，宝马可通过 Cookie 在站内向您显示一般和个性化广告，同时通过包括“记住我”按钮在内的插件提供多种定制化功能以及其他重要功能，包括。我们植入的Cookie不会收集您的任何个人信息。'

t.agreement.content18 = '管理Cookie'

t.agreement.content20 = '大多数浏览器都允许您在偏好设置中管理 Cookie。如果您限制网站储存Cookie，则可能无法享受个性化服务和获得最佳用户体验，也可能无法保存登录信息等自定义设置。'

t.agreement.content21 = '如果您不想使用 Cookie 设置或想要删除Cookie，该如何操作？'

t.agreement.content22 = '如果您不希望我们在您访问宝马网站时使用Cookie，您可以在设置页面选择关闭Cookie。为了识别您已选择关闭 Cookie，我们必须在您的设备上设置 “关闭 Cookie”以 避免在您下次访问时设置其他Cookie。如果您不希望接收Cookie，您也可以在访问宝马网站的电脑或'

t.agreement.content23 = '其他设备中更改浏览器设置。如果您使用宝马网站时没有更改浏览器设置，我们则认为您愿意接收宝马网站 Cookie。许多浏览器的功能允许您查看并删除 Cookie，包括宝马 Cookie。温馨提示: 如果不接收Cookie，宝马网站将不能正常使用。'

t.agreement.confirm = '[{handle}] 秒后可以关闭'

// 业务数据
t.management = {}
t.management.code = '业务编码'
t.management.name = '业务名称'
t.management.nameone = '上级业务名称'
t.management.sort = '排序'
t.management.leafFlag = '无下级节点'

// 内容管理
t.content = {}
t.content.contentColumn = '栏目'
t.content.contentTitle = '文章标题'
t.content.contentDate = '日期'
t.content.contentAuthor = '作者'
t.content.publishDate = '发布时间'
t.content.publisherId = '发布人'
t.content.contentPubStatus = '发布状态'
t.content.contentType = '热门课程类型'
t.content.imgUrl = '缩略图'
t.content.imgUrlMsg = '缩略图（建议上传宽高比为 16:9 的图片）'
t.content.videoUrl = '视频（视频大小在500M以内）'
t.content.description = '简介'
t.content.publishContent = '内容'

// 日历
t.calendar = {}
t.calendar.nameCn = '中文名称'
t.calendar.nameEn = '英文名称'

t.i18n = {}
t.i18n.beijing = '北京'
t.i18n.tianjin = '天津'
t.i18n.hebei = '河北'
t.i18n.shanxi1 = '山西'
t.i18n.neimenggu = '内蒙古'
t.i18n.liaoning = '辽宁'
t.i18n.jilin = '吉林'
t.i18n.heilongjiang = '黑龙江'
t.i18n.shanghai = '上海'
t.i18n.jiangsu = '江苏'
t.i18n.zhejiang = '浙江'
t.i18n.anhui = '安徽'
t.i18n.fujian = '福建'
t.i18n.jiangxi = '江西'
t.i18n.shandong = '山东'
t.i18n.henan = '河南'
t.i18n.hubei = '湖北'
t.i18n.hunan = '湖南'
t.i18n.guangdong = '广东'
t.i18n.guangxi = '广西'
t.i18n.hainan = '海南'
t.i18n.chongqing = '重庆'
t.i18n.sichuang = '四川'
t.i18n.guizhong = '贵州'
t.i18n.yunnan = '云南'
t.i18n.xizang = '西藏'
t.i18n.shanxi3 = '陕西'
t.i18n.gansu = '甘肃'
t.i18n.qinghai = '青海'
t.i18n.ningxia = '宁夏'
t.i18n.xinjiang = '新疆'
t.i18n.taiwan = '台湾'
t.i18n.xianggang = '香港'
t.i18n.aomen = '澳门'
t.i18n.guowai = '国外'
t.i18n.idcard_length = '你输入的身份证长度或格式错误'
t.i18n.idcard_area = '你的身份证地区非法'
t.i18n.idcard_birthday = '身份证上的出生日期非法'
t.i18n.idcard_illegal = '你输入的身份证号非法'

// 邮件
t.mail = {}
t.mailUser = '请选择收件人'
t.selectOrgId = '请先选择公司'

t.img = {}
t.img.type = '仅支持PNG/JPEG/JPG格式的图片'
t.img.maxSize = '上传的图片大小不能超过20m'
t.img.maxSizeTow = '上传的图片大小不能超过4MB'
t.img.maxSizeBack = '上传的图片裁剪后大小不能超过500k'

t.businessData = {}
t.businessData.bussinessTypeCode = '业务数据编码'
t.businessData.bussinessTypeId = '业务数据ID'
t.businessData.bussinessTypeName = '业务数据名称'
t.businessData.sort = '排序'
t.businessData.createUserName = '创建人'
t.businessData.createTime = '创建时间'
t.businessData.updateUserName = '修改人'
t.businessData.updateTime = '修改时间'

t.res = {}

// 课程教室关系管理
t.res.courseclassroomrela = {}
t.res.courseclassroomrela.courseNumber = '课程'
t.res.courseclassroomrela.teamClassification = '团队分类'
t.res.courseclassroomrela.addRela = '新增'
t.res.courseclassroomrela.download = '模板下载'
t.res.courseclassroomrela.import = '导入'
t.res.courseclassroomrela.export = '导出'
t.res.courseclassroomrela.batchDeletion = '批量删除'
t.res.courseclassroomrela.courseNoPlaceholder = '课程代码/课程中文名称'
t.res.courseclassroomrela.classroomPlaceholder = '教室编号/教室中文/英文名称'
t.res.courseclassroomrela.classroomNamePlaceholder = '教室编号/名称'
t.res.courseclassroomrela.courseClassId = '课程分类'
t.res.courseclassroomrela.coursesSatus = '课程状态'
t.res.courseclassroomrela.classroomNo = '教室编号'
t.res.courseclassroomrela.classroomName = '教室名称'
t.res.courseclassroomrela.classroomClass = '教室分类'
t.res.courseclassroomrela.classStatus = '教室状态'
t.res.courseclassroomrela.city = '所属城市'
t.res.courseclassroomrela.classification = '所属场地'
t.res.courseclassroomrela.classroomCount = '上课所需教室数量'
t.res.courseclassroomrela.selectFromLeft = '请点击"课程代码"选择'
t.res.courseclassroomrela.courseId = '课程ID'
t.res.courseclassroomrela.courseNo = '课程代码'
t.res.courseclassroomrela.courseName = '课程中文名称'
t.res.courseclassroomrela.courseTime = '课程时间'
t.res.courseclassroomrela.maxPersonNo = '最大人数'
t.res.courseclassroomrela.miniPersonNo = '最小人数'
t.res.courseclassroomrela.bySystem = '系统自动计算'
t.res.courseclassroomrela.classroompoolExplain1 = '说明：1.教室池是指本课程上课时可供选择的所有备选教室。'
t.res.courseclassroomrela.classroompoolExplain2 = '2.自动排课时，课程默认所需教室数量为教室池数量，每个教室池默认仅安排一个教室。如需更改，请在课程组合管理-课程拆分中设置。'
t.res.courseclassroomrela.classroompoolExplain3 = '3.排课时，每个教室池仅选择一个教室使用。'
t.res.courseclassroomrela.classroompool = '教室池'
t.res.courseclassroomrela.remark = '备注'
t.res.courseclassroomrela.label = 'No.'
t.res.courseclassroomrela.classroomNo = '教室编号'
t.res.courseclassroomrela.roomCnName = '教室名称'
t.res.courseclassroomrela.classroomClass = '教室分类'
t.res.courseclassroomrela.siteName = '所属场地'
t.res.courseclassroomrela.status = '教室状态'
t.res.courseclassroomrela.courseclassroomrelaExcel = '课程教室关系'
t.res.courseclassroomrela.courseclassroomrelaExcelTemple = '课程教室关系模板.xlsx'
t.res.courseclassroomrela.classroomLabel = '教室标签'
t.res.courseclassroomrela.priority = '优先级'
t.res.courseclassroomrela.poolName = '教室池'
t.res.courseclassroomrela.save = '保存'
t.res.courseclassroomrela.close = '关闭'
t.res.courseclassroomrela.determine = '确定'
t.res.courseclassroomrela.remove = '移除'
t.res.courseclassroomrela.addreturn = '返回'
t.res.courseclassroomrela.serialNo = '序号'
t.res.courseclassroomrela.annual = '年份'
t.res.courseclassroomrela.reportAnnualTarget = '年度目标'
t.res.courseclassroomrela.roomArea = '面积'
t.res.courseclassroomrela.maxNo = '人数'
t.res.courseclassroomrela.floor = '楼层'
t.res.courseclassroomrela.liftNo = '举升机数量'
t.res.courseclassroomrela.workplaceNo = '工位数量'
t.res.courseclassroomrela.priorityCheck = '请输入优先级'
t.res.courseclassroomrela.selected = '已选择'
t.res.courseclassroomrela.selectPriority = '优先级未输入'
t.res.courseclassroomrela.selectCheck = '请选择教室'
t.res.courseclassroomrela.selectTeacherCheck = '请选择培训师'
t.res.courseclassroomrela.selectVeichelCheck = '请选择车辆'
t.res.courseclassroomrela.selectRoomCheck = '请选择教室'
t.res.courseclassroomrela.courseTeamClassification = '课程团队分类'
t.res.courseclassroomrela.classroomTag = '教室标签'
t.res.courseclassroomrela.alternativeClassroom = '教室选择'
t.res.courseclassroomrela.ondb = '该教室已选择，请选择其他教室!'
t.res.courseclassroomrela.classroom = '教室'
t.res.courseclassroomrela.alternativeCourse = '课程选择'
t.res.courseclassroomrela.chooseScheduled = '选择排期'
t.res.courseclassroomrela.cannotDelete = '教室池1最后一条数据不能删除'
t.res.courseclassroomrela.course = '请选择课程'
t.res.courseclassroomrela.classroompoolSelect = '请为教室池'
t.res.courseclassroomrela.classroomSelect = '选择教室'
t.res.courseclassroomrela.open = '展开'
t.res.courseclassroomrela.advancedSearch = '高级搜索'
t.res.courseclassroomrela.courseClassId1 = '课程分类1'
t.res.courseclassroomrela.courseClassId2 = '课程分类2'
t.res.courseclassroomrela.courseClassId3 = '课程分类3'
t.res.courseclassroomrela.courseSelectCheck = '请选择课程'
t.res.courseclassroomrela.repeatQuery = '课程代码在关系表中已存在'
t.res.courseclassroomrela.cancelinfo = '有尚未保存的数据,离开将不保存, 确定离开?'
t.res.courseclassroomrela.needSave = '请先保存后再进行编辑！'
t.res.courseclassroomrela.courseTeamCatalog = '课程团队分类'
t.res.courseclassroomrela.addPool = '新增教室池'

// 课程培训师关系管理
t.res.coursetrainerrela = {}
t.res.coursetrainerrela.teamClassification = '课程团队分类'
t.res.coursetrainerrela.trainer = '培训师'
t.res.coursetrainerrela.trainerPlaceholder = '培训师用户ID/培训师中文/英文名称'
t.res.coursetrainerrela.city = '所在城市'
t.res.coursetrainerrela.trainerfication = '培训师团队分类'
t.res.coursetrainerrela.addRela = '新增'
t.res.coursetrainerrela.download = '模板下载'
t.res.coursetrainerrela.import = '导入'
t.res.coursetrainerrela.export = '导出'
t.res.coursetrainerrela.batchDeletion = '批量删除'
t.res.coursetrainerrela.trainerCount = '上课所需培训师数量'
t.res.coursetrainerrela.trainerpoolExplain1 = '说明：1.培训师池是指本课程上课时可供选择的所有备选培训师。'
t.res.coursetrainerrela.trainerpoolExplain2 = '2.自动排课时，课程默认所需培训师数量为培训师池数量，每个培训师池默认仅安排一个培训师。如需更改，请在课程组合管理-课程拆分中设置。'
t.res.coursetrainerrela.trainerpoolExplain3 = '3.排课时，每个培训师池仅选择一个培训师使用。'
t.res.coursetrainerrela.trainerpool = '培训师池'
t.res.coursetrainerrela.trainerUserName = '培训师用户ID'
t.res.coursetrainerrela.userCardNo = '员工号'
t.res.coursetrainerrela.trainerEnName = '姓名'
t.res.coursetrainerrela.company = '所属公司'
t.res.coursetrainerrela.trainerStatus = '培训师状态'
t.res.coursetrainerrela.trainerLabel = '培训师标签'
t.res.coursetrainerrela.qualfication = '合格'
t.res.coursetrainerrela.alternativeTrainer = '培训师选择'
t.res.coursetrainerrela.baseCourseChose = '引用其他课程培训师'
t.res.coursetrainerrela.trainerpoolSelect = '请为培训师池'
t.res.coursetrainerrela.trainerSelect = '选择培训师'
t.res.coursetrainerrela.coursetrainerrelaExcelTemple = '课程培训师关系模板.xlsx'
t.res.coursetrainerrela.coursetrainerrelaExcel = '课程培训师关系'
t.res.coursetrainerrela.cannotDelete = '培训师池1最后一条数据不能删除'
t.res.coursetrainerrela.corporation = '所在公司'
t.res.coursetrainerrela.courseCount = '可授课数量'
t.res.coursetrainerrela.qualficationCheck = '请选择是否合格，不合格需要填写合格日期'
t.res.coursetrainerrela.yearTargetCheck = '请选择是否限制年度目标，限制需要填写数量'
t.res.coursetrainerrela.selectQualfication = '资格未输入'
t.res.coursetrainerrela.trainerNo = '培训师编号'
t.res.coursetrainerrela.orgType = '公司类型'
t.res.coursetrainerrela.annual = '当前年度'
t.res.coursetrainerrela.phonenumber = '手机码'
t.res.coursetrainerrela.jobcodeJoinDate = '加入该职位日期'
t.res.coursetrainerrela.qualfications = '资格'
t.res.coursetrainerrela.trainerrole = '培训师角色'
t.res.coursetrainerrela.companyDistributor = '公司名称'
t.res.coursetrainerrela.ondb = '该培训师已选择，请选择其他培训师!'
t.res.coursetrainerrela.downloadExcelError = '导入文件的错误数据'
t.res.coursetrainerrela.yearTeachGoals = '年度授课次数'
t.res.coursetrainerrela.yearTeachGoalsInfo = '年度授课次数为该培训师每年教授本课程的最大次数,最大值为999999'
t.res.coursetrainerrela.developInfo = '此信息仅用于自动排课，每个培训师池仅可设置1名开发培训师。若选择“是”且未在自动排课前手动安排此培训师，则自动排课时排出的本年度第一期课会默认安排此培训师；若选择“否”，则此培训师全年合格日期范围内任意时间可排课。'
t.res.coursetrainerrela.isDevelop = '是否开发培训师'
t.res.coursetrainerrela.courseNameCode = '课程编码/名称'
t.res.coursetrainerrela.carChose = '车辆选择'
t.res.coursetrainerrela.baseCourseCarChose = '引用其他课程车辆'
t.res.coursetrainerrela.workstation = '工位'
t.res.coursetrainerrela.roomChose = '教室选择'
t.res.coursetrainerrela.baseCourseRoomChose = '引用其他课程教室'
t.res.coursetrainerrela.room = '教室池'
t.res.coursetrainerrela.qualficationDateNeed = '当前不合格需选择预计合格日期！'
t.res.coursetrainerrela.remarkChange1 = '需选择一个培训师后方可进行备注修改！'
t.res.coursetrainerrela.remarkChange2 = '需选择一个教室后方可进行备注修改！'
t.res.coursetrainerrela.remarkChange3 = '需选择一个车辆后方可进行备注修改！'
t.res.coursetrainerrela.remarkChange4 = '需选择一个培训师后方可进行培训师池类型修改！'
t.res.coursetrainerrela.remarkChangeSuccss = '备注修改成功！'
t.res.coursetrainerrela.addPool = '新增培训师池'
t.res.coursetrainerrela.searchCompany = '所属公司'
t.res.coursetrainerrela.isNewDevelop = '每个培训师池最多可选择一名开发培训师，如需修改请先将其他培训师设置为否'
t.res.coursetrainerrela.isQaulified = '是否合格'
t.res.coursetrainerrela.isQaulifiedAll = '全部选择'
t.res.coursetrainerrela.isQaulifiedOnly = '仅合格'
t.res.coursetrainerrela.companyNameCode = '所属组织'
t.res.coursetrainerrela.trainerStatus = '培训师状态'
t.res.coursetrainerrela.trainerMain = '培训师（主）'
t.res.coursetrainerrela.trainerSecondary = '培训师（辅）'
t.res.coursetrainerrela.trainerAssistant = '助教'
t.res.coursetrainerrela.trainerParticipant = '参与者'
t.res.coursetrainerrela.trainerPoolTypeInfo = '培训师池类型修改成功！'

t.res.edit = '编辑'
t.res.activity = '活动'
t.res.noActivity = '不活动'
t.res.getCheckTokenError = '获取access_token失败'
t.res.checkTokenErrorForZCHC = '校验access_token失败'

// 教室信息roomName
t.res.cri = {}
t.res.cri.createTrainRoom = '创建培训教室'
t.res.cri.tag = '标签'
t.res.cri.yearTargetList = '年度目标列表'

t.res.cri.ATTemplateExport = '年度目标模板'
t.res.cri.ATargetImport = '年度目标导入'
t.res.cri.classroomActivityStatus = '确定将教室状态改为“活动”？'
t.res.cri.classroomInactiveStatus = '确定将教室状态改为“不活动”？'
t.res.cri.serialNo = '序号'
t.res.cri.classroomNo = '教室编号'
t.res.cri.sysAutoCreate = '系统自动生成'
t.res.cri.roomName = '教室名称'
t.res.cri.roomCnName = '教室名称'
t.res.cri.inputRoomCnName = '请输入教室名称'
t.res.cri.roomCnAbbr = '教室简称'
t.res.cri.inputRoomCnAbbr = '请输入教室简称'
t.res.cri.subordinateSite = '所属场地'
t.res.cri.classroomClass = '教室分类'
t.res.cri.status = '教室状态'
t.res.cri.startTime = '开始时间'
t.res.cri.ifCount = '是否计算利用率'
t.res.cri.floor = '楼层'
t.res.cri.inputFloor = '请输入楼层'
t.res.cri.file = '是否有教室布局文件'
t.res.cri.classroominfo = '教室信息'
t.res.cri.exportAnnualTarget = '教室年度目标模板'
t.res.cri.download = '是否确定下载教室布局文件？'
t.res.cri.room = '请输入教室名称/简称'

t.res.cri.edit = '编辑'
t.res.cri.unInactive = '不活动'
t.res.cri.inactive = '活动'
t.res.cri.calendar = '日历'

t.res.cri.roomTag = '教室标签'

t.res.cri.save = '保存'
t.res.cri.endTime = '结束时间'
t.res.cri.inputEndTime = '请输入结束时间'
t.res.cri.rentalFee = '租用费用(元)'
t.res.cri.inputRentalFee = '请输入租用费用(元)'
t.res.cri.managementFee = '管理费用(元)'
t.res.cri.inputManagementFee = '请输入管理费用(元)'
t.res.cri.cateringExpenses = '餐饮费用(元)'
t.res.cri.inputCateringExpenses = '请输入餐饮费用(元)'
t.res.cri.ifCount = '是否计算利用率'
t.res.cri.roomArea = '面积'
t.res.cri.inputRoomArea = '请输入面积'
t.res.cri.floor = '楼层'
t.res.cri.liftNo = '举升机数量'
t.res.cri.inputLiftNo = '请输入举升机数量'
t.res.cri.workplaceNo = '工位数量'
t.res.cri.inputWorkplaceNo = '请输入工位数量'
t.res.cri.uploadLayoutFiles = '上传教室布局文件'
t.res.cri.maxNo = '最大人数'
t.res.cri.inputMaxNo = '请输入最大人数'

t.res.cri.operation = '操作'
t.res.cri.tagType = '标签类别'
t.res.cri.tagContent = '标签内容'
t.res.cri.year = '年份'
t.res.cri.yearTarget = '报表年度目标'

// 教室信息-> 表单校验
t.res.cri.r = {}
t.res.cri.r.roomCnName = '教室中文名称不能为空'
t.res.cri.r.roomCnAbbr = '教室中文简称不能为空'
t.res.cri.r.classroomClass = '教室分类不能为空'
t.res.cri.r.siteId = '所属场地不能为空'
t.res.cri.r.status = '教室分类不能为空'
t.res.cri.r.startTime = '开始时间不能为空'
t.res.cri.r.rentalFee = '租用费用不能为空'
t.res.cri.r.managementFee = '管理费用不能为空'
t.res.cri.r.cateringExpenses = '餐饮费用不能为空'
t.res.cri.r.ifCount = '是否统计不能为空'

t.res.cri.r.notNull = '不能为空'
t.res.cri.r.nonnegativeFloat = '请输入非负的数字'
t.res.cri.r.phoneCheck = '请输入正确的电话'
t.res.cri.r.nonnegativeInteger = '请输入非负的整数'
t.res.cri.r.number = '楼层请输入正整数'
t.res.cri.r.annual = '年度目标列表中，年份不能为空！'
t.res.cri.r.annualCheck = '年度目标列表中，只能输入当前及以后年份！'
t.res.cri.r.reportAnnualTarget = '年度目标列表中，年度目标值不能为空！'
t.res.cri.r.reportAnnualTargetCheck = '报表年度目标值必须为正整数！'
t.res.cri.r.reportAnnualCheck = '年份必须为正整数！'
t.res.cri.r.yearCheck = '年份已经存在！'
t.res.cri.r.upload = '上传教室布局文件'
t.res.cri.r.checkSiteInfoEndTime = '开始时间不能晚于结束时间！'

// 所属场地
t.res.cri.site = {}
t.res.cri.site.siteNo = '场地编号'
t.res.cri.site.siteCnName = '场地中文名称'
t.res.cri.site.siteCnAbbr = '场地中文简称'
t.res.cri.site.siteId = '所属公司'
t.res.cri.site.siteClassId = '场地分类'
t.res.cri.site.status = '状态'
t.res.cri.site.siteInfo = '场地信息'
t.res.cri.site.siteClass = '实体场地与虚拟场地不允许相互切换！'
t.res.cri.site.siteClassroomType = '所属场地类型必须与教室分类类型保持一致！'
t.res.cri.site.cityIdNull = '所在城市不能为空!'
t.res.cri.site.companyIdNull = '所属公司不能为空!'
t.res.cri.site.addressNull = '场地地址不能为空!'
t.res.cri.site.cateringExpenses = '餐饮费用请输入正确的数'

t.res.cri.site.pleaseChooseData = '请选择数据'

// 场地信息
t.res.site = {}
t.res.site.serialNumber = '序号'
t.res.site.name = '场地名称'
t.res.site.nameOrAbbr = '场地名称/简称'
t.res.site.code = '场地编号'
t.res.site.siteActivityStatus = '确定将场地状态改为“活动”？'
t.res.site.siteInactiveStatus = '确定将场地状态改为“不活动”？'
t.res.site.shortName = '场地简称'
t.res.site.inputShortName = '请输入场地简称'
t.res.site.type = '所属分类'
t.res.site.selectType = '请先选择所属分类'
t.res.site.company = '所属公司'
t.res.site.city = '所在城市'
t.res.site.classification = '场地分类'
t.res.site.label = '场地标签'
t.res.site.status = '场地状态'
t.res.site.ChineseName = '场地名称'
t.res.site.inputChineseName = '请输入场地名称'
t.res.site.contacts = '联系人'
t.res.site.inputContacts = '请输入联系人'
t.res.site.telephone = '联系电话'
t.res.site.inputTelephone = '请输入联系电话'
t.res.site.address = '场地地址'
t.res.site.inputAddress = '请输入场地地址'
t.res.site.startTime = '开始时间'
t.res.site.endTime = '结束时间'
t.res.site.inputEndTime = '请输入结束时间'
t.res.site.cateringExpenses = '餐饮费用'
t.res.site.notNull = '不能为空'
t.res.site.selectSiteInfo = '选择场地'
t.res.site.createClassroom = '创建教室'
t.res.site.ondb = '该场地已选择，请选择其他场地!'
t.res.site.selected = '已选场地'

// 车辆信息管理
t.res.vehinfo = {}
t.res.vehinfo.serialNo = '序号'
t.res.vehinfo.chassisNo = '车辆底盘号'
t.res.vehinfo.inputChassisNo = '请输入17位车辆底盘号'
t.res.vehinfo.vehicleClassId = '车型分类'
t.res.vehinfo.label = '车辆标签'
t.res.vehinfo.vehicleClassification = '车辆分类'
t.res.vehinfo.companyId = '所属公司'
t.res.vehinfo.subordinateSiteId = '所属场地'
t.res.vehinfo.presentSiteId = '当前场地'
t.res.vehinfo.status = '车辆状态'
t.res.vehinfo.isUpload = '是否有配置信息'
t.res.vehinfo.upload = '上传车辆配置详细信息文件(上传格式为jpg/png/xlsx/xls/zip/rar/txt/pdf文件)'
t.res.vehinfo.upFile = '上传文件'
t.res.vehinfo.uploadTips = '只能上传一个文件'
t.res.vehinfo.edit = '编辑'
t.res.vehinfo.check = '查看'
t.res.vehinfo.yes = '是'
t.res.vehinfo.no = '否'
t.res.vehinfo.inactive = '活动'
t.res.vehinfo.unInactive = '不活动'
t.res.vehinfo.calendar = '日历'
t.res.vehinfo.replaceVeh = '替换车辆'
t.res.vehinfo.rdCodeId = '研发代码'
t.res.vehinfo.brandId = '品牌'
t.res.vehinfo.productionDate = '生产日期'
t.res.vehinfo.inputProductionDate = '请输入生产日期'
t.res.vehinfo.startTime = '开始时间'
t.res.vehinfo.endTime = '结束时间'
t.res.vehinfo.inputEndTime = '请输入结束时间'
t.res.vehinfo.endTime = '结束时间'
t.res.vehinfo.ifCount = '是否计算利用率'
t.res.vehinfo.engineModel = '发动机型号'
t.res.vehinfo.inputEngineModel = '请输入发动机型号'
t.res.vehinfo.remark = '备注'
t.res.vehinfo.inputRemark = '请输入备注'
t.res.vehinfo.ATTemplateExport = '车辆信息模板'
t.res.vehinfo.ATargetImport = '车辆信息导入'
t.res.vehinfo.save = '保存'
t.res.vehinfo.back = '返回'
t.res.vehinfo.replace = '车辆替换'
t.res.vehinfo.replaceCar = '被替换车辆'
t.res.vehinfo.replaceNewCar = '替换新车辆'
t.res.vehinfo.startDate = '开始时间'
t.res.vehinfo.endDate = '结束时间'
t.res.vehinfo.export = '车辆信息管理'
t.res.vehinfo.selected = '已选车辆'
t.res.vehinfo.exportAnnualTarget = '车辆信息年度目标模板'
t.res.vehinfo.ondb = '该车辆已选择，请选择其他车辆!'
t.res.vehinfo.vehicleActivityStatus = '确定将车辆状态改为“活动”？'
t.res.vehinfo.vehicleInactiveStatus = '确定将车辆状态改为“不活动”？'
t.res.vehinfo.select = '请选择'
t.res.vehinfo.input = '请输入'
t.res.vehinfo.download = '是否确定下载车辆配置文件'
t.res.vehinfo.exportError = '错误信息'

// 车型分类，教室分类
t.res.classroom = {}
t.res.classroom.unFold = '展开所有'
t.res.classroom.fold = '收起所有'
t.res.classroom.activity = '活动'
t.res.classroom.see = '显示'
t.res.classroom.baseInfo = '基本信息'
t.res.classroom.pName = '上级节点名称'
t.res.classroom.state = '分类状态'
t.res.classroom.name = '分类名称'
t.res.classroom.isSynchro = '是否同步'
t.res.classroom.synchro = '同步'
t.res.classroom.isBatchUpload = '是否允许批量上传'

// 课程车辆关系维护
t.res.rela = {}
t.res.rela.courseNumber = '课程代码'
t.res.rela.course = '课程'
t.res.rela.courseName = '课程中文名称'
t.res.rela.courseTeamClassification = '课程团队分类'
t.res.rela.teamClassification = '团队分类'
t.res.rela.vehiclesNumber = '课程所需车辆数量'
t.res.rela.workstation = '工位'
t.res.rela.priority = '优先级'
t.res.rela.status = '状态'
t.res.rela.operation = '操作'
t.res.rela.addRela = '新增'
t.res.rela.download = '模板下载'
t.res.rela.import = '导入'
t.res.rela.export = '导出'
t.res.rela.batchDeletion = '批量删除'
t.res.rela.courseState = '课程状态'
t.res.rela.coursevehiclerela = '课程与车辆关系'
t.res.rela.courseVehicleRelaTemple = '课程与车辆关系模板.xlsx'

t.res.rela.courseDate = '课程时间'
t.res.rela.miniPersonNo = '最小人数'
t.res.rela.courseClass = '课程分类'
t.res.rela.Number = '课程所需车辆数量'
t.res.rela.determine = '确定'
t.res.rela.courseClass1 = '课程分类1'
t.res.rela.courseClass2 = '课程分类2'
t.res.rela.courseClass3 = '课程分类3'
t.res.rela.isUpload = '车辆配置信息'
t.res.rela.label = 'NO'
t.res.rela.altervehicles = '备选车辆'
t.res.rela.addreturn = '返回'
t.res.rela.insert = '新增'
t.res.rela.addPool = '新增工位'
t.res.rela.delete = '移除'
t.res.rela.alternativeCourse = '选择课程'
t.res.rela.alternativeVehicles = '选择备选车辆'
t.res.rela.priorityCheck = '优先级不能为空'
t.res.rela.selectCheck = '您未选中任何数据！'
t.res.rela.selectPriority = '请选择优先级！'
t.res.rela.selectCourseNo = '请选择课程编号！'
t.res.rela.selectDelete = '请选中需要删除的数据！'
t.res.rela.onOk = '所选车辆在该工位已存在，请重新勾选！'
t.res.rela.courseId = '请选择课程！'
t.res.rela.station = '请在工位中选择车辆！'
t.res.rela.select = '请点击"课程代码"选择'

// 经销商部门管理
t.res.department = {}
t.res.department.departmentName = '部门名称'
t.res.department.departmentCnName = '部门名称'
t.res.department.departmentEnName = '部门英文名称'
t.res.department.parentDepartmentName = '上级部门名称'
t.res.department.createDepartment = '新增'
t.res.department.code = '部门代码'
t.res.department.icon = '部门图标'
t.res.department.addJobs = '添加职位'
t.res.department.jobName = '职位名称'
t.res.department.jobCode = '职位代码'
t.res.department.deleteDepartment =
  '删除该部门时将同时删除其下属部门，是否确认删除该部门？'
t.res.department.deleteDep = '是否确认删除该部门？'
t.res.department.deleteJob =
  '删除该职位时将同时删除其下属职位，是否确认删除该职位？'
t.res.department.deletePosition = '是否确认删除该职位？'

// 经销商组织架构模板管理
t.res.departmentTemple = {}
t.res.departmentTemple.keyword = '关键词'
t.res.departmentTemple.name = '模板名称'
t.res.departmentTemple.templeName = '模板名称'
t.res.departmentTemple.templeEnName = '模板英文名称'
t.res.departmentTemple.createTemple = '新增'
t.res.departmentTemple.scale = '经销商规模'
t.res.departmentTemple.delete = '删除'
t.res.departmentTemple.addOrg = '添加部门'
t.res.departmentTemple.addNextPost = '新增下级部门'
t.res.departmentTemple.addNextJob = '新增下级职位'
t.res.departmentTemple.selectJob = '选择职位'
t.res.departmentTemple.selectDepartment = '选择部门'
t.res.departmentTemple.job = '职位'
t.res.departmentTemple.department = '部门'

// 经销商组织架构建议值维护
t.res.departmentValue = {}
t.res.departmentValue.upSearch = '高级搜索'
t.res.departmentValue.nameCode = '经销商名称/编号'
t.res.departmentValue.type = '网点类型'
t.res.departmentValue.shopType = '网点状态'
t.res.departmentValue.groupName = '集团名称'
t.res.departmentValue.city = '所在城市'
t.res.departmentValue.exportTemple = '导出模板'
t.res.departmentValue.importStandardValue = '导入参考值'
t.res.departmentValue.shopName = '经销商名称'
t.res.departmentValue.checkStandardValue = '查看参考值'
t.res.departmentValue.seeOrgTree = '查看组织架构'
t.res.departmentValue.departmentJobName = '部门/职位名称'
t.res.departmentValue.standardNum = '参考人数'
t.res.departmentValue.exportTemple = '经销商组织架构参考值模板'
t.res.departmentValue.export = '导出模板'

// 课程
t.couse = {}
t.couse.couseq = '开课前()天/小时截止报名/替换'
t.couse.jiez = '截止报名(替换)'
t.couse.qiy = '启用等候名单'
t.couse.yxdealer = '允许店内替换'
t.couse.pxx = '培训需求收集'
t.couse.xz = '限制撤销报名'
t.couse.xxc = '限制撤销报名天数'
t.couse.rxc = '允许重复报名'
t.couse.dealer = '经销商'
t.couse.limit = '限制'
t.couse.dealerwx = '无限制'
t.couse.xdstandard = '限定标准'
t.couse.ynstudy = '是否限制查看'
t.couse.ynstudyoffering = '是否限制查看和报名'
t.couse.zpush = '站内信推送'
t.couse.mgroup = '面向组群'
t.couse.creatmgroup = '创建组群'
t.couse.createques = '等同课程维护'
t.couse.allowjob = '允许兼职职位报名'
t.couse.blendRead = '读取'
t.couse.blendNread = '不读取'
t.couse.blendnotes = '注：若勾选读取混合式学习前置课，学员报名时必须完成对应混合式学习中的前置课程'
t.couse.blendnotesmsg = '此面授课尚未关联混合式学习'

t.couse.allname = '课程名称'
t.couse.allstate = '培训记录状态要求'
t.couse.alltype = '学习对象类型'
t.couse.allcz = '操作'

t.couse.courseprice = '价格(￥)'
t.couse.rewardscore = '奖励积分'
t.couse.noshowpenalty = '缺勤扣款(￥)'
t.couse.consumptionscore = '消费积分'
t.couse.coureschex = '撤销报名扣款'
t.couse.couresadd = '+添加撤销报名扣款规则'
t.couse.budgetline = '预算号'
t.couse.cousrq = '课程开始日期之前'
t.couse.couresday = '天（含）撤销，扣款'
t.couse.couresdele = '删除'
t.couse.whetherreturn = '通过后是否返还'
t.couse.BBASplit = 'BBA分账比例'

// 课程列表查询
t.couse.brand = '品牌'
t.couse.coursecatalogid = '课程分类'
t.couse.courseteamcatalogid = '课程团队分类'
t.couse.course = '课程'
t.couse.coursename = '课程名称'
t.couse.coursestatus = '课程状态'
t.couse.coursekind = '学习对象'
t.couse.coursekind1 = '课程类型'
t.couse.courselabel = '课程标签'
t.couse.collectiondemandflag = '培训需求收集'
t.couse.limitvisiableflag = '是否限制查看'
t.couse.createuser = '创建人'
t.couse.createtime = '创建时间'
t.couse.endData1 = '结束时间'
t.couse.startdate1 = '开始时间'
// 调查问卷url
t.couse.investigationAddressurl = 'http://joylearning.bmw.bmw.com.cn:7000/'

// 子页面
t.couse.coursekinds = '学习对象类型'
t.couse.courseCoursekinds = '学习对象类型'
t.couse.courseNamecns = '课程中文名称'

// 课程列表
t.couse.no = '序号'
t.couse.coursecode = '课程代码'
t.couse.coursenamecn = '课程中文名称'
t.couse.coursenameen = '课程英文名称'
t.couse.coursestatus = '课程状态'
t.couse.count = '需求人数'
t.couse.handle = '操作'
t.couse.coursedays = '标准时长（天）'
t.couse.intervalTime = '间隔时长(月)'
t.couse.maxnumber = '最大人数'
t.couse.minnumber = '最小人数'
t.couse.undercarriage = '下架'
t.couse.active = '发布'
t.couse.keepon = '存档'
t.couse.delete = '删除'
t.couse.courseExport = '课程导出'
t.couse.edit = '编辑'
t.couse.coursecodes = '课程名称'
t.couse.courseNamecn = '课程中文名'
t.couse.courseCoursekind = '课程类型'
t.couse.couseImporttemplate = '报名人数导入模板'
t.couse.coursectotle = '课程代码/名称'
t.couse.groupName = '组群名称'
t.couse.groupRemark = '组群描述'
t.couse.createUserName = '创建人'
t.couse.limitCourseStartdate = '课程限制报名有效期'
t.couse.limitCourseEnddate = '      '
t.couse.startdate = '开始日期'
t.couse.enddate = '结束日期'
t.couse.conditiontile = '前提条件'
t.couse.conditionnotice = '注：选项与选项之间为“或”（OR）的关系；选项中子项与子项之间为“与”（AND）的关系'
t.couse.conditiondesc = '已报名：用户在报名本课程前必须已报名前提课，且在本课程开始日期N天之前必须完成该前提课程，否则会产生撤销扣款'
t.couse.conditionlimit = '限制报名人数'
t.couse.conditionlimitOption = '限制查看设置'
t.couse.offringclass = '排课'
t.couse.option = '选项'
t.couse.begincourse = '选项内的课程在课程开始'
t.couse.daysago = '天前完成'
t.couse.coursequres = '课程查询'
t.couse.csreplace = '截止报名(替换)'
t.couse.csend = '截止替换时间与截止报名日期一致'
t.couse.csaddnew = '添加新选项'
t.couse.cssignup = '人报名'
t.couse.csupload = '点击上传'
t.couse.cszupload = '自定义上传'
t.couse.csdealerno = '除上传经销商外，其他经销商不受限制'
t.couse.csgroupq = '面向组群查询'
t.couse.equestitle = '等同关系'
t.couse.equecombination = '组合'
t.couse.equespackage = '等同包'
t.couse.equescoursecode = '课程代码'
t.couse.equesname = '课程名称'
t.couse.equestype = '学习对象类型'
t.couse.equesstate = '课程状态'
t.couse.csgroututitle = '面向组群'
t.couse.applytitle = '开课申请详情'
t.couse.applyuserName = '申请人'
t.couse.applyorgName = '所属公司'
t.couse.applycityName = '期望授课城市'
t.couse.applyapplyDate = '申请时间'
t.couse.applyapprovalUserName = '审批人'
t.couse.applyapprovalDate = '审批时间'
t.couse.applyapprovalStatus = '审批状态'
t.couse.applyYear = '年份'

// 课程分类
t.catalog = {}
t.catalog.catalognamecn = '分类名称'
t.catalog.catalogstatus = '分类状态'
t.catalog.courseLevel = '课程优先级'

// course 基本信息
t.course = {}
t.course.courseBrand = '品牌'
t.course.courseclassify = '课程分类'
t.course.courseTeamCatalogId = '课程团队分类'
t.course.maxNumber = '最大人数'
t.course.minNumber = '最小人数'
t.course.courseNameCn = '课程中文名称'
t.course.courseNameEn = '课程英文名称'
t.course.courseIntroduction = '课程介绍'
t.course.courseDays = '标准时长（天）'
t.couse.intervalTime = '间隔时长(月)'
t.course.projectCourseFlag = '允许培训师排课'
t.course.courseKind = '课程类型'
t.course.courseCode = '课程代码'
t.course.covers = '封面图片'
t.course.banner = '横幅图片'
t.course.agCodes = 'AG关联课程代码'
t.course.passMarkFlag = '是否设置及格分数线'
t.course.passMarkScore = '及格分数'
t.course.undercarriagemsg = '为避免本次操作会给混合式学习带来不便，烦请到混合式学习中确认该课程是否被使用后，再做处理。'
t.couse.appcatalog = 'APP课程层级'
t.course.titletian = '时长为0时，不收集签到'

t.couse.exportMsg = '选中序号列前的勾选框，可导出当页数据；不勾选任何选项，可导出全部数据'
t.couse.premisetMsg = '前提条件/前置条件更改将同步到所有已发布/未发布排期，已结束排期不会发生变更'
t.couse.conditionlimitMsg = '限制更改将同步到所有已发布/未发布排期，已结束排期不会发生变更'
t.couse.groupMsg = '面向群组更改将同步到所有已发布/未发布排期，已结束排期不会发生变更'
t.couse.whetherReturnMsg = 'xxxxxxxxx'

t.couse.noticetDealerMsg = '仅适用于报名成功后经销商管理员收到的通知'
t.couse.noticetMsg = '适用于学员'
t.course.edit = '编辑'
t.course.validDate = '预计合格日期'
t.course.mutliAction = '批量操作'
t.course.courseNameCode = '请填写课程编码/名称'


// course 公共
t.course.tag = '课程标签'
t.course.plsin = '请输入'
t.course.pls = '请'
t.course.select = '请选择'
t.course.query = '查询'
t.course.plsInputCodeorName = '课程代码/名称'

// 导航
t.course.csbase = '基本信息'
t.course.cscondition = '报名条件'
t.course.csprice = '价格相关'
t.course.csrpt = '报表相关'
t.course.csinvest = '调查问卷'
t.course.csability = '能力项设置'

// 页面保存
t.course.saveAndNext = '保存并下一步'
t.course.save = '保存'
t.course.cancel = '取消'
t.course.saveAndRelease = '保存并发布'
t.course.next = '下一步'
t.course.remove = '关闭'
t.course.return = '返回'

// 报表相关
t.course.countUtilizationFlag = '是否统计在课程使用率报表'
t.course.quickTestFlag = '通过率报表分类'
t.course.intervalTime = '间隔时长(月)'
t.course.serioustraining = '是否统计在培训认证通过率报表'

// 调查问卷
t.course.investigationName = '调查问卷'
t.course.investigationAddress = '问卷地址'
t.course.center = '操作'
t.course.delete = '移除'
t.course.operation = '操作'
t.course.addInvestigationName = '+添加问卷'
t.course.addOK = '添加调查文件成功'

// 课程创建完成
t.course.courseReleaseOK = '课程发布成功！'
t.course.coursebtnJumpOffering = '创建排期 >>'
t.course.courseTrainer = '课程培训师关系维护 >>'
t.course.courseTeacher = '课程教室关系维护   >>'
t.course.courseVehicle = '课程车辆关系维护   >>'

t.course.deletewarn = '当前课程有未发布或已发布状态的排期，不可删除'
t.course.undercarriagewarn = '当前课程有未发布或已发布状态的排期，不可下架'
t.course.pleaseChooseData = '请选择数据'
t.course.ondb = '该课程已选择，请选择其他课程!'
t.couse.selectedCourse = '已选课程'

// 排期相关
t.offering = {}
t.offering.selectCourse = '选择课程'
t.offering.courseDays = '实际时长（天）'
t.offering.catalog = '课程分类'
t.offering.teamCatalogId = '团队课程分类'
t.offering.startdate = '开始时间'
t.offering.enddate = '结束时间'
t.offering.location = '所在场地'
t.offering.local = '场地'
t.offering.city = '所在城市'
t.offering.offeringNo = '排期编号'
t.offering.offeringRemark = '备注'
t.offering.offringname = '排期名称'
t.offering.tag = '课程标签'
t.offering.offringstatus = '排期状态'
t.offering.no = '序号'
t.offering.countuser = '报名人数'
t.offering.trainer = '培训师'
t.offering.creator = '创建人'
t.offering.releaseTime = '排期发布时间'
t.offering.view = '查看'
t.offering.edit = '编辑'
t.offering.listDelete = '删除'
t.offering.copy = '复制'
t.offering.cancel = '取消'
t.offering.cancelview = '查看取消'
t.offering.distribution = '分配'
t.offering.showplist = '人员名单'
t.offering.offeringExport = '排期导出'
t.offering.downloadtemplate = '模板下载'
t.offering.batchImport = '模板上传'
t.offering.report = '上传结果'
t.offering.Release = '发布'
t.offering.saveemail = '本次修改，请确认是否发送变更通知？'
t.offering.batchdeletion = '删除'
t.offering.trainerId = '培训师编号'
t.offering.trainerType = '培训师类型'
t.offering.trainerName = '培训师名称'
t.offering.starttime = '排期时间（开始）'
t.offering.endtime = '排期时间（结束）'
t.offering.actualdays = '实际培训时间（天）'
t.offering.operation = '操作'
t.offering.more = '操作'
t.offering.resourceing = '时间区间内有资源占用,请重新选择！'
t.offering.cancereasons = '请选择取消原因'
t.offering.cancereasonselect = '请选择原因'
t.offering.canceremarks = '备注'
t.offering.courseNameCncan = '面授课程'
t.offering.registNumbercan = '报名人数'
t.offering.waitingnumbercan = '已加入等候名单'
t.offering.startdatecan = '培训日期'
t.offering.siteNamecan = '地点'
t.offering.checkListNull = '请选择需要发布的排期'
t.offering.deletetips = '该排期已产生培训记录，不能删除'
t.offering.cancelreasonstips = '请选择取消原因'
t.offering.membershipPassword = '入会密码'
t.offering.recurringMeeting = '周期性会议'
t.offering.yes = '是 (默认选中状态)'
t.offering.noSec = '否'
t.offering.repeatFrequency = '重复频率'
t.offering.endRepetition = '结束重复'
t.offering.meetingSettings = '会议设置'
t.offering.openMeetingRegistration = '开启会议报名'
t.offering.openWaitingRoom = '开启等候室'
t.offering.conferenceEntry = '允许成员在主持人进会前进入会议'
t.offering.conferenceWatermark = '开启会议水印'
t.offering.joinMute = '成员入会时静音'
t.offering.turnOn = '开启 (默认选中状态)'
t.offering.closure = '关闭'
t.offering.turnOnSec = '开启'
t.offering.liveConference = '会议直播'
t.offering.setHost = '设置主持人'
// 排期导航
t.offering.offbase = '基本信息'
t.offering.offeringResources = '排期资源'
t.offering.offconditionAdd = '报名条件'
t.offering.offnoticeAdd = '报名通知'
t.offering.offpriceAdd = '价格相关'
t.offering.offinvestAdd = '调查问卷'
t.offering.offabilityAdd = '能力项设置'
// 排期调查问卷
t.offering.courseInvestigation = '面授课问卷'
t.offering.trainerInvestigation = '培训师问卷'
t.offering.select = '请选择'
t.offering.investigationId = '问卷编号'
t.offering.investigationName = '问卷名称'
t.offering.investigationDesc = '问卷描述'
t.offering.investigationAddress = '问卷地址'
t.offering.delete = '移除'
t.offering.investigationoperation = '操作'
t.offering.addCourseInvestigation = '添加面授课问卷'
t.offering.addTrainerInvestigation = '添加培训师问卷'
t.offering.addInvestigationName = '+添加问卷'

// 排期创建完成
t.offering.offeringReleaseOK = '排期发布成功！'
t.offering.offeringReleasecopy = '复制排期 >>'
t.offering.newOffering = '创建新的排期   >>'
// 通知方式
t.offering.signUpNoticeError = '通知方式不能为空'
t.offering.signUpNoticeConError = '模板内容不能为空'
t.offering.signUpNoticedefError = '请在原模版下方追加通知内容，并保持原模版样式不变'

t.offering.startErrorSave = '该排期状态已被修改，不允许编辑'


t.offering.resourceIsNotice00 = '排期时间已修改，请注意是否需要更改排期资源时间。'
t.offering.resourceIsNotice0 = '修改排期时间或场地时，系统默认向已报名的学员及其管理员发送提醒排期调整的通知：'
t.offering.resourceIsNotice1 = '若更改排期时间和场地，为避免经销商收到重复通知，请点击不发送；'
t.offering.resourceIsNotice2 = '若仅更改排期时间，不更改场地，请点击发送。'
t.offering.offeringadminYN = '本店人员报名排期'
t.offering.mutliUpdate = '批量组群更新'


t.site = {}
t.site.selectSiteInfo = '场地'
t.site.name = '场地名称'
t.site.code = '场地编号'
t.site.classification = '场地分类'
t.site.status = '活动状态'
t.site.city = '所在城市'
t.site.serialNo = '序号'
t.site.type = '所属分类'
t.site.classification = '场地分类'
t.site.status = '场地状态'

// ************选择课程查询页面*********** */
t.offeringcd = {}
t.offeringcd.cousername = '课程名称'
t.offeringcd.cousercode = '课程代码'
t.offeringcd.cousernamecn = '课程中文名称'
t.offeringcd.cousernameen = '课程英文名称'
t.offeringcd.courseDays = '标准时长(天)'
t.offeringcd.couserTeamcatalog = '课程团队分类'
t.offeringcd.cousercatalog = '课程分类'
t.offeringcd.cousertype = '课程类型'
t.offeringcd.couserstate = '课程状态'

// 审批报表
t.registe = {}
t.registe.username = '姓名'
t.registe.placeholderName = '请输入姓名'
t.registe.positionname = '职位'
t.registe.placeholderPositionName = '请输入职位'
t.registe.coursename = '课程名称'
t.registe.placeholderCourseName = '请输入课程名称'
t.registe.startdate = '开始时间'
t.registe.enddate = '结束时间'
t.registe.applyflag = '类型'
t.registe.no = 'NO.'
t.registe.userId = '用户ID'
t.registe.orgname = '经销商'
t.registe.coursename = '课程名称'
t.registe.offeringname = '排期名称'
t.registe.applydate = '申请时间'
t.registe.approvalstatus = '审批状态'
t.registe.approvalusername = '审批人'
t.registe.revokeUserName = '撤销操作人'
t.registe.agree = '同意'
t.registe.refuse = '拒绝'
t.registe.revokeremark = '撤销理由'
t.registe.approvalremark = '审批意见'
t.registe.change = '替换'
t.registe.revoke = '撤销'
t.registe.updataSign = '修改签到记录'
t.registe.updataSignMark = '修改签到记录及分数'
t.registe.lookSignMark = '查看签到记录及分数'
t.registe.lookSignMark2 = '查看签到记录'
t.registe.cancelPenalty = '免除'
t.registe.immune = '已免除'
t.registe.adduser = '添加用户'
t.registe.addusererror = '添加结果页'
t.registe.dealer = '经销商'
t.registe.company = '所属公司'
t.registe.pleaseChoose = '请选择'
t.registe.attendanceRecord = '签到记录'
t.registe.mark = '分数'
t.registe.queryWaitingList = '查看等候名单'
t.registe.displayRevokedList = '显示已撤销的用户'
t.registe.adduser = '添加用户'
t.registe.orgType = '经销商类型'
t.registe.selected = '已选对象'
t.registe.save = '保存'
t.registe.submission = '提交'
t.registe.cancel = '取消'
t.registe.sendEmail = '发送邮件'
t.registe.sendNotice = '发送通知'
t.registe.selectCheck = '请选择用户'
t.registe.select = '请选择'
t.registe.pleaseSelect = '请选择用户'
t.registe.input = '请输入'
t.registe.no1 = '不收取撤销扣款'
t.registe.no2 = '不发送撤销通知'
t.registe.penaltyAmount = '扣款金额(元)'
t.registe.immuneAmount = '免除金额:'
t.registe.firstname = '姓'
t.registe.lastname = '名'
t.registe.confirmAssign = '确认为以下人员分配课程？'
t.registe.accountBalance = '可用金额(元):'
t.registe.unfreezeBalance = '欲解冻余额(元):'
t.registe.availablBlaance = '汇总金额(元):'
t.registe.blaanceuserid = '用户ID'
t.registe.blaanceDealer = '所属公司'
t.registe.orgType = '组织类型'
t.registe.blaanceMCKD = '所属母店(CKD)'
t.registe.blaancePrice = '排期价格'
t.registe.blaanceexempt = '减免金额'
t.registe.blaancePay = '支付金额'
t.registe.blaanceaccount = '付费后可用余额'
t.registe.blaanceState = '状态'
// 分配管理
t.registe.changecourse = '选择课程'
t.registe.offeringcode = '排期编号'
t.registe.offeringname = '排期名称'
t.registe.offeringstatus = '排期状态'
t.registe.city = '所在城市'
t.registe.place1 = '所在场地'
t.registe.coursecode = '课程编号'
t.registe.coursename = '课程名称'
t.registe.trainer = '培训师'
t.registe.place2 = '场地'
t.registe.trainday = '实际培训时间'
t.registe.applycount = '报名人数'
t.registe.assign = '分配'
t.prompt.beyond = '剩余席位不足'

// 培训记录
t.registe.applyassigndate = '申请/分配时间'
t.registe.changeuser = '替换学员'
t.registe.select = '请从左侧选择....'
t.registe.showuser = '人员名单'

// 分配课程
t.assign = {}
t.assign.assigncourse = '分配课程'
t.assign.positionname = '主要职位'
t.assign.idcard = '身份证号'
t.assign.idNumber = '证件编号'
t.assign.email = '邮箱编码'
t.assign.Email = '邮箱'
t.assign.bbaNo = 'BBA No.(CKD)'
t.assign.nscNo = 'NSC No.(CBU)'
t.assign.approvalStatus = '审核状态'
t.assign.signupApprovalStatus = '报名审批状态'
t.assign.abbreviationCn = '所属公司'
t.assign.parttimejobone = '兼职职位1'
t.assign.parttimejobtwo = '兼职职位2'
t.assign.partTimeJobThree = '兼职职位3'
t.assign.partTimeJobFour = '兼职职位4'
t.assign.partTimeJobFive = '兼职职位5'
t.assign.dealershiptype = '经销商类型'
t.assign.status = '状态'
t.assign.time = '时间'
t.assign.updateTime = '最后修改时间'
t.assign.userExport = '人员名单导出'
t.assign.timeRange = '创建时间(起始)'
t.assign.updateTimeRange = '最后修改时间(起始)'
t.assign.viewrevoke = '查看撤销'
t.assign.replaceuser = '替换用户'
t.assign.offeringdetail = '排期详细信息'
t.assign.detail = '详细信息'
t.assign.trainingdate = '培训日期'
t.assign.startEndDate = '开始时间-结束时间:'
t.assign.registeAbbreviationAn = '报名时所属公司:'
t.assign.site = '地点'
t.assign.Facetofacecourses = '面授课程:'
t.assign.course = '课程:'
t.assign.countuser = '报名人数:'
t.assign.trainingdate = '培训日期:'
t.assign.learner = '学员:'
t.assign.site = '地点:'
t.assign.coureschex = '撤销报名扣款:'
t.assign.revokeset = '撤销设置'
t.assign.immuneInfo = '免除信息'
t.assign.immune = '详细信息'
t.assign.revokeuser = '撤销学员:'
t.assign.revokereason = '请选择撤销原因*:'
t.assign.opinion = '意见:'
t.assign.save = '保存'
t.assign.commits = '提交'
t.assign.accountBalance = '可用余额(元):'
t.assign.bbaNom = '母店BBA No.(CKD)'
// 认证
t.cert = {}
t.cert.certName = '认证名称'
t.cert.plsInput = '请输入认证编号/中英文'
t.cert.brand = '品牌'
t.cert.certType = '认证分类'
t.cert.certStatus = '认证状态'
t.cert.copyCert = '复制规则'
t.cert.certCode = '认证编号'
t.cert.createUserName = '创建人'
t.cert.createDate = '创建时间'
t.cert.edit = '编辑'
t.cert.delete = '删除'
t.cert.undercarriage = '下架'
t.cert.select = '请选择'
t.cert.more = '更多'
t.cert.baseinfo = '基本信息'
t.cert.ralacourse = '关联相关课程'
t.cert.certtemplaterule = '认证模板及规则'
t.cert.recertrule = '延续认证规则'
t.cert.certassessmentdate = '重新有效规则'
t.cert.baseinfoset = '基本信息设定'
t.cert.certRule = '认证规则'
t.cert.certTemplate = '认证模板'
t.cert.certreRule = '延续认证规则设定'
t.cert.certreEffectiveRuleSetting = '重新有效规则设定'
t.cert.selectTips = '请选择'
t.cert.inputTips = '请输入'
t.cert.certCode = '认证编号'
t.cert.autobysystem = '系统自动生成'
t.cert.certNameCn = '认证中文名称'
t.cert.certNameEn = '认证英文名称'
t.cert.pleaseCheckTheTopic = '请检查认证介绍必填项'
t.cert.introduceContent = '介绍内容'
t.cert.brand = '品牌'
t.cert.certLevel = '认证级别'
t.cert.courseTeamCatalog = '认证团队分类'
t.cert.cancel = '取消'
t.cert.save = '保存'
t.cert.savefornext = '保存并下一步'
t.cert.saveforrelease = '保存并发布'
t.cert.cancelinfo = '离开本页将不保存当前正在编辑的数据, 确定离开?'
t.cert.validPeriod = '认证有效期'
t.cert.recertFlag = '认证需延续'
t.cert.recertFlagTips = '选择否时，延续认证规则将被删除'
t.cert.selectTemplate = '选择证书模板'
t.cert.ruleExplain = '注：选项与选项之间为"或"（OR）的关系；选项中子项与子项之间为"与"（AND）的关系'
t.cert.ruleOption = '选项'
t.cert.coursename = '课程名称'
t.cert.authenticationAttributes = '认证属性'
t.cert.completeStatus = '培训记录状态要求'
t.cert.coursekind = '学习对象类型'
t.cert.addOption = '添加新选项'
t.cert.selectcourse = '选择课程'
t.cert.optionDescription = '选项说明'
t.cert.writeOptionDescription = '请填写选项说明'
t.cert.annualRecert = '延续认证年'
t.cert.renewForAnotherYear = '重新延续年'
t.cert.maximumExtensionDeadline = '最大延续截止日期'
t.cert.particularYear = '年'
t.cert.annualRecertExplain = '注：延续的时间和认证有效期需要匹配，每一年的延续规则单独设置'
t.cert.addCertDup = '相同品牌，认证分类和认证级别的认证已存在'
t.cert.pleaseSelectCert = '请选择要复制的认证'
t.cert.copyFont = '复制'
t.cert.ruleToFont = '的规则至'
t.cert.ruleCopyNotice = '注：规则包含“关联相关课程”和“认证模板及规则”'
t.cert.confirm = '确认'
t.cert.pleaseSelectYearFrom = '请选择复制源年份'
t.cert.pleaseSelectYearTo = '请选择复制目标年份'
t.cert.noCertFrom = '{yearFrom}年的认证规则不存在'
t.cert.hasCertTo = '{yearTo}年的认证规则已存在'
t.cert.underStatusCannotCopy = '已下架的认证不能复制规则'
t.cert.unreleasedStatusCannotCopy = '未发布的认证不能复制规则'
t.cert.excelCertInfo = '认证信息表'
t.cert.certYear = '认证获得年'
t.cert.FCC = '认证介绍'
t.cert.determines = '确 定'
t.cert.cancellation = '取 消'
t.cert.pleaseEntertext = '请输入文本，最多500字'
t.cert.addImage = '添加图片'
t.cert.addTexts = '添加文本'
t.cert.addVedio = '添加视频'
t.cert.TextCannotExceed = '文本不能超过500字，图片不能大于20MB，格式为png，jpeg及jpg'
t.cert.VedioCannotExceed = '视频不能超过1G，格式为mp4，mov。'
t.cert.afterUploadingVideo = '视频上传完成后可点击图片自定义视频头图'
t.cert.addCertYear = '新增认证获得年'
t.cert.aMakeUpExam = '允许失效认证重新有效'
t.cert.automaticContinuation = '自动延续'
t.cert.makeUpExaminationTo = '截止至'
t.cert.closingDatepre = '于'
t.cert.closingDate = '前完成'
t.cert.courseRequired = '关联相关课程不能为空'
t.cert.optionCourseRequired = '没有添加关联相关课程'
t.cert.closingDateRequired = '截止日期不允许为空'
t.cert.stepSaveRequired = '其中有未保存页，不能发布认证'
t.cert.pleaseInputcertName = '请输入认证名称'
t.cert.certruleSaveRequired = '该认证获得年的认证规则信息未保存'
t.cert.recertruleRequired = '该认证获得年的认证规则信息不需要延续'
t.cert.pleaseSelectCertName = '请选择认证名称'
t.cert.pleaseSelectCertOptions = '不显示'
t.cert.next = '下一步'
t.cert.close = '关闭'
t.cert.add = '添加'
t.cert.completeStatusRequired = '有课程的培训记录状态要求未选择'
t.cert.selectedCourse = '已选课程'
t.cert.selectedScheduled = '已选排期'
t.cert.courseondb = '该课程已选择，请选择其他课程!'
t.cert.return = '返回'
t.cert.templateName = '模板名称'
t.cert.keyword = '请输入关键词'
t.cert.templateNo = '模板编号'
t.cert.preview = '预览'
t.cert.pleaseSelectTemplate = '请选择认证模板'
t.cert.message = '消息'
t.cert.coursekinds = '学习对象类型'
t.cert.appcatalog = 'APP课程层级'
t.cert.courseStatus = '课程状态'
t.cert.courseNameEn = '课程英文名称'
t.cert.selectCourse = '选择课程'
t.cert.certTeamCatalog = '认证团队分类'
t.cert.courseTeamCatalog2 = '课程团队分类'
t.cert.courseNameCnLen = '认证中文名称字节长度不能超过70'
t.cert.noCertData = '该认证已删除'
t.cert.certStatusisDown = '该认证已下架，不允许编辑'
t.cert.exportMsg = '选中序号列前的勾选框，可导出当页数据；不勾选任何选项，可导出全部数据'
t.cert.inputCourse = '课程代码/名称'
t.cert.saveEditData = '是否确认保存当前正在编辑的数据?'
t.cert.synchronousUpdate = '变更后以下认证获得年的重新有效规则会同步更新：'
t.cert.rerulecourseRequired = '延续认证关联相关课程不能为空'
t.cert.authenticationAttributesErrorMessage = '认证属性不能为空'
t.cert.reoptionCourseRequired = '没有添加延续认证关联相关课程'
t.cert.saveAnnualRecertDataPre = '是否确认保存'
t.cert.saveAnnualRecertDataSuf = '年编辑的延续认证规则数据?'
t.cert.appcertbadge = 'APP认证徽章'
t.cert.selectfile = '选取文件'
t.cert.uploadTips = '建议尺寸比例2.2：1，不超过4M，格式为png,jpeg及jpg'

t.cert.year = '年度'
t.cert.brand2 = '经销商品牌'
t.cert.trainCategory = '考核类型'
t.cert.trainCategoryCode = '考核类型代码'
t.cert.jobCategory = '项目分类'
t.cert.jobCategoryCode = '项目分类代码'
t.cert.downloadtemplate = '导出模板'
t.cert.startUpload = '开始上传'
t.cert.orgType = '网点类型'
t.cert.openDate = '开业时间'
t.cert.position = '主职职位'
t.cert.courseCode = '认证编号/课程代码'
t.cert.courseName = '认证/课程名称'
t.cert.finishTime = '要求完成时长(天)'
t.cert.finishDate = '要求时长(天)'
t.cert.exportBase = '基础考核项设置模板'
t.cert.exportSpec = '特殊考核项设置模板'
t.cert.exportTarget = '经销商目标模板'
t.cert.exportInhourse = '内训规则模板'
t.cert.exportOnDuty = '在岗人数考核设置模板'
t.cert.nscno = 'NSC(CBU)'
t.cert.bbano = 'BBA(CKD)'
t.cert.openYear = '开业年份'
t.cert.openingDate = '开业日期'
t.cert.downloadExcelError = '导入文件的错误数据'
t.cert.keyCertNameAbbr = '认证/课程别名'
t.cert.orgCode = '组织编号'
t.cert.minOnJobNum = '最低在岗人数目标'
t.cert.targetValue = '目标'
t.cert.minOnJobMonth = '最低在岗人数累积(月)'
t.cert.month = '月份'
t.cert.yearmonth = '年月'
t.cert.jobCategoryGroupCode = '关键基础岗分组'
t.cert.numberEntors = '指导人数'
t.cert.assessmentType = '考核方式'
t.cert.projectClassificationKey='关键基础岗项目分类'


t.offering.resource = {}
t.offering.resource.selectSite = '选择场地'
t.offering.resource.delete = '删除'
t.offering.resource.cleanConfirmMsg = '修改场地将会清空除培训师外的全部资源，确定清空?'
t.offering.resource.asignConfirmMsg = '该学员已经完成了等同课程，是否继续报名?'

t.offering.resource.trainer = '设置培训师'
t.offering.resource.trainerno = '序号'
t.offering.resource.trainerId = '用户ID'
t.offering.resource.trainerType = '培训师类型'
t.offering.resource.trainerName = '姓名'
t.offering.resource.trainerstarttime = '排期时间（开始）'
t.offering.resource.trainerendtime = '排期时间（结束）'
t.offering.resource.traineractualdays = '实际培训时间（天）'
t.offering.resource.traineroperation = '操作'
t.offering.resource.trainerConfirmMsg = '教师资源将被清空，确定清空?'
t.offering.resource.trainerDeleteConfirmMsg = '教师资源将被删除，确定删除?'
t.offering.resource.trainerNullMsg = '无教师资源信息，无需删除！'
t.offering.resource.traineractualdaysWarn = ':教师实际培训时间格式不正确！'
t.offering.resource.room = '设置教室'
t.offering.resource.roomno = '序号'
t.offering.resource.roomId = '教室编号'
t.offering.resource.roomType = '教室类型'
t.offering.resource.roomName = '教室名称'
t.offering.resource.roomCnAbbr = '教室简称'
t.offering.resource.roomCnSite = '所属场地'
t.offering.resource.roomstarttime = '使用时间（开始）'
t.offering.resource.roomendtime = '使用时间（结束）'
t.offering.resource.roomactualdays = '实际培训时间（天）'
t.offering.resource.roomoperation = '操作'
t.offering.resource.roomConfirmMsg = '教室资源将被清空，确定清空?'
t.offering.resource.roomDeleteConfirmMsg = '教室资源将被删除，确定删除?'
t.offering.resource.roomNullMsg = '无教室资源信息，无需删除！'
t.offering.resource.roomactualdaysWarn = ':教室实际培训时间格式不正确！'
t.offering.resource.vehicle = '设置车辆'
t.offering.resource.vehicleid = '序号'
t.offering.resource.vehicleNo = '车辆底盘号'
t.offering.resource.vehicleType = '车型分类'
t.offering.resource.vehicleName = '车辆名称'
t.offering.resource.vehicleBrand = '品牌'
t.offering.resource.vehiclestarttime = '使用时间（开始）'
t.offering.resource.vehicleendtime = '使用时间（结束）'
t.offering.resource.vehicleactualdays = '实际培训时间（天）'
t.offering.resource.vehicleoperation = '操作'
t.offering.resource.vehicleConfirmMsg = '车辆资源将被清空，确定清空?'
t.offering.resource.vehicleDeleteConfirmMsg = '车辆资源将被删除，确定删除?'
t.offering.resource.vehicleNullMsg = '无车辆资源信息，无需删除！'
t.offering.resource.vehicleactualdaysWarn = ':车辆实际培训时间格式不正确！'
t.offering.resource.material = '设置资产耗材'
t.offering.resource.materialno = '序号'
t.offering.resource.materialRequisitionsId = '领用单号'
t.offering.resource.materialType = '培训师类型'
t.offering.resource.materialName = '培训师名称'
t.offering.resource.materialstarttime = '使用时间（开始）'
t.offering.resource.materialendtime = '使用时间（结束）'
t.offering.resource.materialactualdays = '实际培训时间（天）'
t.offering.resource.materialoperation = '操作'
t.offering.resource.materialConfirmMsg = '资产耗材资源将被清空，确定清空?'
t.offering.resource.materialDeleteConfirmMsg = '资产耗材资源将被删除，确定删除?'
t.offering.resource.materialNullMsg = '无资产耗材资源信息，无需删除！'
t.offering.resource.materialactualdaysWarn = ':资产耗材实际培训时间格式不正确！'
t.offering.resource.tencentConferenceRoom = '腾讯会议室'
t.offering.resource.settingUpTencentMeetings = '设置腾讯会议'
t.offering.resource.conferenceTheme = '会议主题'

t.authApply = {}
t.authApply.fileName = '已上传文件'
t.authApply.allowAllowAdminJobNames = '允许设置为管理员的职位'
t.authApply.uploadFileFirst = '请上传《BMW悦学苑平台经销商管理员授权委托书》'
t.authApply.fileFormatContent = '只支持PDF或图片格式(*.pdf,*.jpg,*.jpeg,*.png,*.bmp)，文件不得超过20MB'
t.authApply.fileFormatMsg = '请上传PDF格式或图片格式文件'

t.assessment = {}
t.assessment.delete = '取消申请'
t.assessment.applyConfirm = '确定申请'
t.assessment.resume = '填写简历'
t.assessment.improve = '完善简历'
t.assessment.positionName = '评估职位'
t.assessment.addUser = '添加用户'
t.assessment.result = '评估中心结果'
t.assessment.assessmentStatus = '能力评估状态'
t.assessment.regionalInterviewResult = '区域反馈'
t.assessment.developCenterState = '发展中心结果'
t.assessment.joinPositionStatus = '加入该职位状态'
t.assessment.dealerName = '当前经销商'
t.assessment.dealerGroupName = '当前经销商集团'
t.assessment.assessTimes = '评估次数'
t.assessment.brand = '当前品牌'
t.assessment.site = '能力评估场地'
t.assessment.offer = '排期编号'
t.assessment.offerNumber = '排期编号'
t.assessment.offerTime = '能力评估日期'
t.assessment.offerStartTime = '开始日期'
t.assessment.offerEndTime = '结束日期'
t.assessment.application = '申请测评'
t.assessment.expertAssessOffer = '能力评估日期'
t.assessment.userInput = '请输入用户ID/姓名/员工号'
t.assessment.detail = '评估详情'
t.assessment.positionRecord = '任职记录'
t.assessment.currentPositionName = '当前主要职位'
t.assessment.selectionMessage = '请选择要添加的用户'
t.assessment.contact = '联系方式'
t.assessment.confirm = '确认'
t.assessment.confirmAssessment = '确认申请'
t.assessment.cancel = '取消'
t.assessment.cancelAssessment = '取消申请'
t.assessment.messageForJob = '请选择测评职位'
t.assessment.messageForContact = '请填写联系方式'
t.assessment.onlineTestStatus = '在线测试'
t.assessment.outletType = '当前网点类型'
t.assessment.recruitmentDealerName = '评估时经销商'
t.assessment.recruitmentBrand = '评估时品牌'
t.assessment.recruitmentOutletType = '评估时网点类型'
t.assessment.limitAccess = '限制测评'
t.assessment.limitAccessRole = '选择被限制用户'
t.assessment.limitAccessRoleValid = '请选择被限制用户!'
t.assessment.limitSelect = '请选择'
t.assessment.limitSetInvalid = '设置测评记录无效'
t.assessment.limitSetInvalidValid = '请选择测评记录是否无效!'
t.assessment.limitAccessApply = '限制测评申请'
t.assessment.limitAccessApplyValid = '请选择是否限制测评申请!'
t.assessment.factoryEvaluation = '厂家备注'
t.assessment.factoryEvaluationValid = '请填写厂家备注，最多500字!'
t.assessment.invalidInfo = '如选择“设置”，所有关键岗位测评记录将更新为“无效”且无法再次上岗关键管理岗。如已在岗，则不影响。'
t.assessment.limitInfo = '如选择“限制”，将无法再为该用户发起新的关键岗位测评申请。'
t.assessment.noSetting = '不设置'
t.assessment.limit = '限制'
t.assessment.noLimit = '不限制'
t.assessment.factoryInfo = '该评价对经销商管理员、经销商管理层、区域经理均可见。'
t.assessment.userLimit = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。前往人才发展-评估中心-邀请候选人测评，可发起测评邀请。'
t.assessment.limitDesc = '该候选人暂无有效的关键管理职位评测记录，不可分配正式职位，请先分配非特殊职位。请查阅以下厂家备注：'
t.assessment.limitDesc2 = '无法为该用户发起测评申请，请查阅以下厂家备注：'
t.assessment.all = '全部'
t.assessment.limitSuccess = '提交限制测评成功!'
t.assessment.factoryFile = '上传厂家通函'
t.assessment.factoryFileTitle = '查看厂家通函文件'
t.assessment.factoryFileInfo = '上传厂家通函文件,不超过4M，仅支持PDF格式!'
t.assessment.factoryFileUpload = '上传通函'
t.assessment.checkCharacter = '查看性格测试报告'
t.assessment.checkSence = '查看情景测试报告'
t.assessment.checkArea = '查看区域反馈'
// t.assessment.applyLimitInfo = '建议6个月内将会上岗的人员报名能力评估。储备人才无需参加能力评估，可以先行参加履新研修课程。'
t.assessment.applyLimitInfo = '建议您为即将上岗人员报名能力测评；如该候选人为关键管理岗位储备人才，则无需报名测评也可参与相应岗位的履新研修课程。'

// 弹窗消息管理
t.pop = {}
t.pop.no = '序号'
t.pop.theme = '主题'
t.pop.themeTitle = '弹窗主题'
t.pop.themePlaceHolder = '请输入弹窗主题'
t.pop.typeText = '类型'
t.pop.title = '名称标题'
t.pop.brand = '品牌'
t.pop.orgName = '所属公司'
t.pop.userName = '提交人'
t.pop.createTimes = '提交时间'
t.pop.creatorTitle = '创建人'
t.pop.creatorPlaceHolder = '请输入创建人名字'
t.pop.createTime = '创建时间'
t.pop.chgTime = '修改时间'
t.pop.type = '类型'
t.pop.status = '活动状态'
t.pop.editorTitle = '修改人'
t.pop.editorPlaceHolder = '请输入修改人名字'
t.pop.type = '类型'
t.pop.popType = '弹窗类型'
t.pop.cover = '封面'
t.pop.connetSelect = '关联选择'
t.pop.link = '网页链接'
t.pop.linkPlaceHolder = '请输入网页链接'
t.pop.group = '面向群组'
t.pop.publisher = '发布人'
t.pop.publishTime = '发布时间'
t.pop.popStatus = '弹窗状态'
t.pop.imgContent = '图文内容'
t.pop.imgContentPlaceHolder = '可输入不超过500字的文字信息'
t.pop.uploadCover = '上传封面'
t.pop.uploadCoverInfo = '请上传封面'
t.pop.chose = '选择'
t.pop.imgInfo = '*建议尺寸比例1:1.33，不超过4m，格式为gif、png、jpeg或jpg'
t.pop.imgInfo2 = '* 建议尺寸比例2.2:1，不超过4m，格式为png、jpeg或jpg'
t.pop.fileUpload = '文件上传'
t.pop.validTime = '生效时间'
t.pop.noValidTime = '失效时间'
t.pop.addText = '添加文本'
t.pop.addImg = '添加图片'
t.pop.choseGroup = '选择群组'
t.pop.queryType1 = '全部'
t.pop.queryType2 = '作品'
t.pop.queryType3 = '提问'
t.pop.queryType4 = '话题'
t.pop.courseType1 = '微课'
t.pop.courseType2 = '资料'
t.pop.courseType4 = '慕课'
t.pop.courseType5 = '混合式学习'
t.pop.courseType6 = '直播'
t.pop.courseType7 = '问吧'
t.pop.id = '编号'
t.pop.team = '业务团队'
t.pop.oneLevel = '一级分类'
t.pop.ownTheme = '所属主题'
t.pop.expect = '期望'
t.pop.problem = '问题'
t.pop.dataName = '资料名称'
t.pop.mukeName = '慕课名称'
t.pop.live = '直播名称'
t.pop.zhihu = '名称/标题'
t.pop.upload = '上传'
t.pop.moduleChose = '模板选择'
t.pop.moduleEdit = '模板编辑'
t.pop.titleFooter = '页尾'
t.pop.confirmDown = '你确定要下架吗？'
t.pop.confirmDel = '你确定要删除吗？'
t.pop.confirmUp = '你确定要发布吗？'
t.pop.bfont = '粗体'
t.pop.ifont = '斜体'
t.pop.lffont = '居左'
t.pop.centerfont = '居中'
t.pop.lrfont = '居右'
t.pop.font = '字体大小'
t.pop.groupPlaceHolder = '请选择群组'
t.pop.linkPlaceHolder = '请选择关联链接'
t.pop.typePlaceHolder = '请选择类型'
t.pop.weblinkPlaceHolder = '请填写网页链接'
t.pop.fileInput = '请上传文件'
t.pop.imgIput = '请填写图文内容'
t.pop.endTimeInfo = '结束时间不可以在今日之前!'
t.pop.imginfoPlaceHolder = '可以输入不超过500字的文字信息'
t.pop.effectivStart = '生效开始时间'
t.pop.effectivEnd = '生效结束时间'
t.pop.downloadtemplate = '下载模板'
t.pop.choseFile = '选取文件'
t.pop.mutliuplateSuccess = '批量更新成功,可下载Excel查看详情!'
t.pop.mutliuplateError = '批量更新失败,请下载Excel查看具体原因!'

//合同管理
t.contract = {}
t.contract.supplierCode = '组织编号'
t.contract.supplierName = '供应商名称'
t.contract.supplierNameCn = '供应商名称(中文)'
t.contract.type = '合同类型'
t.contract.status = '合同状态'
t.contract.id = '合同编号'
t.contract.idInfo = '合同编号(采购订单号)'
t.contract.name = '合同名称'
t.contract.orgNumber = '组织编号'
t.contract.team = '合同所属团队'
t.contract.teamName = '所属团队'
t.contract.inputTips = '请输入'
t.contract.selectTips = '请选择'
t.contract.export = '导出'
t.contract.timeStartEnd = '合同起止日期'
t.contract.createTime = '创建时间'
t.contract.supplierId = '供应商代码'
t.contract.companyCn = '公司名称(中文)'
t.contract.companyEn = '公司名称(英文)'
t.contract.validTime = '合同生效时间'
t.contract.novalidTime = '合同失效时间'
t.contract.foodSupplier = '餐饮供应商合同'
t.contract.foodSupplierSpace = '餐饮供应商服务场地'
t.contract.brunch = '上午餐点(元)'
t.contract.lunch = '午餐(元)'
t.contract.dinner = '下午餐点(元)'
t.contract.totalMoney = '每日合计'
t.contract.trainerSupplier = '培训供应商合同'
t.contract.travelExpensesAirTicket = '差旅费-单程机票(元)'
t.contract.travelExpensesTaxi = '差旅费-当地交通(元)'
t.contract.travelExpensesHotel1 = '差旅费-一级城市酒店单价(元)'
t.contract.travelExpensesHotel2 = '差旅费-二级城市酒店单价(元)'
t.contract.trainerLevel = '培训师等级'
t.contract.addLevel = '新增等级'
t.contract.levelIndex = '序号'
t.contract.costName = '费用名称'
t.contract.costMoney = '不含税单价(元)'
t.contract.costUnit = '单位'
t.contract.costType = '费用类别'
t.contract.trainerLevelName = '等级名称'
t.contract.trainerMoneyLocal = '教师培训费-本地(元)'
t.contract.trainerMoneyOut = '教师培训费-外地(元)'
t.contract.trainerMoneySubsidy = '周末上课补助(元)'
t.contract.teamNoOrCode = '请输入组织编号或名称进行查询'
t.contract.timeValid = '失效日期不可小于生效日期！'
t.contract.noInfoSupplierNo = '供应商组织编号不可为空'
t.contract.noInfoContractNo = '合同编号不可为空'
t.contract.noInfoSupplierId = '供应商代码不可为空'
t.contract.noInfoCompanyName = '公司名称不可为空'
t.contract.noInfoBeginTime = '生效日期不可为空'
t.contract.noInfoEndTime = '失效日期不可为空'
t.contract.noInfoStatus = '合同状态不可为空'
t.contract.noInfoTeam = '合同所属团队不可为空'
t.contract.noInfoType = '合同类型不可为空'
t.contract.addSuccess = '新建合同成功'
t.contract.editSuccess = '修改合同成功'
t.contract.statusUpdate = '合同状态更新成功'
t.contract.titleValid = '不可输入空格等特殊字符'
t.contract.supplierCodeInfo = '新增供应商请前往系统管理-组织管理进行维护'
t.contract.updateTime = '更新时间'
t.contract.newCost = '新增费用项'
t.contract.costPlaceHolder = '请选择费用项类别'
t.contract.costTrainer = '培训师费用'
t.contract.addCost = '新增费用条目'
t.contract.foodCost = '餐饮费用'
t.contract.trainerPoolCost = '培训场地费用'
t.contract.grantCost = '补助费用'
t.contract.certLevel = '认证等级'
t.contract.consumablesLevel = '耗材等级'
t.contract.costLevelIndexInfo = '合同条款编号不可重复!'
t.contract.costLevelIndexInfo2 = '存在同一费用项中序号相同,请修改'
t.contract.costNeedValid = '费用明细各项必填，不可为空'
t.contract.costTypeInfo = '费用项类别不可为空'
t.contract.trainerContractType = '培训师所属合同'
t.contract.trainerContractLevel = '培训师合同等级'
t.contract.trainerContractTypeValid = '培训师所属合同不可为空'
t.contract.trainerContractLevelValid = '培训师合同等级不可为空'
t.contract.noLevel = '无合同等级'
t.contract.noContract = '无合同'
t.contract.serial = '合同条款编号'
t.contract.otherCostInfo = '费用条目重复'
t.contract.trainerInfo = '如果合同里没有异地培训师费用的话，则费用类别选择：本地培训师费用'
t.contract.trainerInfo2 = '费用条目重复'
t.contract.saveInfo = '使用说明：完成全部编辑后请点击页面右下角确认按钮保存。'
t.contract.backInfo = '若点击确定按钮将回退本次修改内容,请确认！'
t.contract.historyBeginTime = '请选择生效时间'
t.contract.historyEndTime = '请选择失效时间'
t.contract.sureSaveContract = '合同信息保存后无法编辑，请确认维护的信息是否准确'
t.contract.mutliContractManage = '批量更新培训师合同'
t.contract.trainerContractTemplate = '培训师合同模板'
t.contract.trainerContractMulti = '批量培训师合同.xlsx'
t.contract.noContractInfo = '使用说明：无合同无等级请先维护合同后才可新增！'
t.contract.nowActiveContract = '该版本为当前生效版本'
t.contract.nowActiveContract2 = '备注：带标记版本为当前生效版本！若需更新合同信息，请点击【新增】。在生效时间与当前时间匹配的情况下，最新添加的合同信息为当前版本。'
t.contract.nowActiveContract3 = '该合同被引用且生效或即将生效，不可修改活动状态'
t.contract.historyContratInfoActive = '(当前生效)'
t.contract.historyContratInfoInfo = '未来生效的版本{handle}已失效，如需重新生效，请重新添加版本信息'

// 课程组合管理
t.courseGroup = {}
t.courseGroup.name = '课程组合'
t.courseGroup.no = '排序'
t.courseGroup.courseNameOrNo = '组合(课程)编号/名称'
t.courseGroup.inputTips = '请输入'
t.courseGroup.status = '课程组合状态'
t.courseGroup.groupType = '组合团队分类'
t.courseGroup.createTime = '创建时间'
t.courseGroup.courseId = '课程组合编号'
t.courseGroup.courseNameCn = '课程组合中文名称'
t.courseGroup.courseNameCnInfo = '请输入课程组合中文名称'
t.courseGroup.courseNameEn = '课程组合英文名称'
t.courseGroup.courseNameEnInfo = '请输入课程组合英文名称'
t.courseGroup.updateTime = '更新时间'
t.courseGroup.courseTeam = '课程组合团队分类'
t.courseGroup.courseTeamInfo = '请选择课程组合团队分类'
t.courseGroup.courseTeamOneInfo = '请课程组合团队一级分类'
t.courseGroup.courseTeamTwoInfo = '请选择二级分类'
t.courseGroup.courseCode = '课程组合代码'
t.courseGroup.sysAutoCreate = '系统自动生成'
t.courseGroup.courseTime = '排课时长'
t.courseGroup.courseTimeInfo = '因排课系统限制,课程组合时长需要以0.5天为最小单位,自动向上取值'
t.courseGroup.sysAutoCalculate = '系统自动计算'
t.courseGroup.courseType = '课程组合类型'
t.courseGroup.courseTypeInfo = '请选择课程组合类型'
t.courseGroup.courseList = '课程列表'
t.courseGroup.addCourse = '新增课程'
t.courseGroup.addSplit = '新增间隔'
t.courseGroup.courseIndex = '课程编号'
t.courseGroup.courseName = '课程名称'
t.courseGroup.courseDay = '排课时长'
t.courseGroup.courseDayOrigin = '实际时长(天)'
t.courseGroup.trainerNum = '所需培训师数量'
t.courseGroup.trainerChose = '培训师池及数量选择'
t.courseGroup.classroomNum = '所需教室数量'
t.courseGroup.classroomChose = '教室池及数量选择'
t.courseGroup.courseStatus = '课程状态'
t.courseGroup.addSplitClass = '新增分节'
t.courseGroup.selectCourse = '已选课程编号'
t.courseGroup.selectCourseTime = '已选课程天数'
t.courseGroup.maxTrainer = '培训师池数量'
t.courseGroup.maxClass = '教室池数量'
t.courseGroup.splitName = '分节名称'
t.courseGroup.selectTips = '请先选择课程'
t.courseGroup.split = '分节'
t.courseGroup.splitAddInfo = '已超过课程最大时长，请修改分节课程数'
t.courseGroup.splitAddInfo2 = '已是最大时长，不可新增'
t.courseGroup.splitAddInfo3 = '已达到最大分节数，不可新增'
t.courseGroup.splitAddInfo4 = '所选课程天数超过课程时长，请修改!'
t.courseGroup.splitAddInfo5 = '分节天数需等于课程时长!'
t.courseGroup.splitAddInfo6 = '分节天数不可为空!'
t.courseGroup.splitAddInfo7 = '培训师池数量需等于所需培训师数量！'
t.courseGroup.splitAddInfo8 = '教室池数量需等于所需教室数量！'
t.courseGroup.trainerPool = '培训师池'
t.courseGroup.classroomPool = '教室池'
t.courseGroup.maxChoseInfo = '已达最大值，全部选择'
t.courseGroup.courseChoseInfo = '请选择课程！'
t.courseGroup.trainerChoseInfo = '已选培训师池对应的培训师数量至少选择1个！'
t.courseGroup.trainerChoseInfo2 = '存在培训师池，不可为空！'
t.courseGroup.trainerNullInfo = '请先维护该课程的培训师池！'
t.courseGroup.classNullInfo = '请先维护该课程的教室池！'
t.courseGroup.classChoseInfo = '已选教室池对应的教师数量至少选择1个！'
t.courseGroup.classChoseInfo2 = '存在教室池，不可为空！'
t.courseGroup.addSplitSuccess = '课程拆分成功'
t.courseGroup.addCombineSuccess = '课程组合保存成功'
t.courseGroup.groupPublish = '课程组合状态变更成功！'
t.courseGroup.combineAddInfo = '课程列表第一行不可新增间隔！'
t.courseGroup.combineAddInfo2 = '间隔前后需要为课程！'
t.courseGroup.combineAddInfo3 = '课程间隔时间需填写，1-60之间整数'
t.courseGroup.combineSplitInfo = '课程间隔可选时间1-60天，可设置区间浮动小于等于2天。间隔可包括周末与节假日，按自然日计算。若排课结果中间隔与节假日相邻或重叠，实际间隔有可能大于设置的间隔。'
t.courseGroup.combineAddInfo4 = '间隔不可连续！'
t.courseGroup.delInfo = '课程组合删除成功！'
t.courseGroup.splitHistory = '课程已被拆分过，请勿重复拆分！'
t.courseGroup.sureSplitCoure = '添加该课程将引用课程组合'
t.courseGroup.sureSplitCoure2 = ',请确认是否添加'
t.courseGroup.isEditTime = ',点击确认进入编辑页面'
t.courseGroup.choseCourse = '已选择课程'
t.courseGroup.combineCourseLimit = '备注：参与课程组合的课程需要设置过培训师池与教室池，联排课程支持多选，每次最多可选10门。'
t.courseGroup.combineCourseLimit2 = '若加入联排的面授课存在状态为活动的课程拆分，则按照课程拆分进行排课，否则按照面授课进行排课。'
t.courseGroup.splitLine = '至'
t.courseGroup.numInfo = '数量'
t.courseGroup.noClassRoom = '无教室池'
t.courseGroup.courseTipsInfo = '备注：参与课程组合的课程需要设置过培训师池与教室池'
t.courseGroup.creator = '创建人'
t.courseGroup.noValidTrainer = '失效培训师池'
t.courseGroup.noValidClassRoom = '失效教室池'
t.courseGroup.typeInfo = '若需要多个课程联合排课，请选择课程联排；若某门课不同时间段使用的培训师、教室资源不同，请选择课程拆分。'
t.courseGroup.headerInfo1 = '拆分后，若相邻分节选择了相同培训师池，则强制使用相同培训师'
t.courseGroup.headerInfo2 = '拆分后，若相邻分节选择了相同教室池，则强制使用相同教室'
t.courseGroup.headerInfo3 = '相邻课程优先安排相同培训师'
t.courseGroup.headerInfo4 = '相邻课程优先安排相同教室'

//合同管理
t.courseSchedule = {}
t.courseSchedule.year = '年度'
t.courseSchedule.choseTips = '请选择'
t.courseSchedule.courseType = '课程类型'
t.courseSchedule.choseArea = '选择场地'
t.courseSchedule.stieChose = '场地选择'
t.courseSchedule.stieName = '场地名称'
t.courseSchedule.stieIndex = '场地编号'
t.courseSchedule.stieType = '场地分类'
t.courseSchedule.stieCity = '所在城市'
t.courseSchedule.stieStatus = '场地状态'
t.courseSchedule.courseClass = '课程分类'
t.courseSchedule.city = '所在区域/城市'
t.courseSchedule.courseNameCode = '课程名称/编号'
t.courseSchedule.teamCatalog = '团队分类'
t.courseSchedule.inputFile = '导入'
t.courseSchedule.courseAndPackage = '课程/课程组合'
t.courseSchedule.courseTaskTime = '排课时长（天）'
t.courseSchedule.courseTaskLevel = '排课优先级'
t.courseSchedule.addTips = '1.选择周末可排课则可能会安排该课程周末上课,不会安排法定节假日; 2.请以课程结束日期设置每月排课目标'
t.courseSchedule.choseCourseCode = '已选课程编号'
t.courseSchedule.choseCourseTime = '课程排课时长'
t.courseSchedule.weekendClass = '周末可排课'
t.courseSchedule.month = '月'
t.courseSchedule.settingMode = '设置模式'
t.courseSchedule.setTotal = '总次数'
t.courseSchedule.siteInfo = '场地选择不可为空'
t.courseSchedule.addSuccess = '新增排课任务成功！'
t.courseSchedule.editSuccess = '编辑排课任务成功！'
t.courseSchedule.delSuccess = '删除成功！'
t.courseSchedule.courseCombine = '课程联排'
t.courseSchedule.courseSplit = '课程拆分'
t.courseSchedule.courseChoseFrist = '请先选择课程！'
t.courseSchedule.courseShowInfo = '备注：参与排课的课程需要设置过培训师池与教室池;课程所在分类需要配置排课优先级;课程状态需为已发布;课程组合状态需为活动;存在活动课程拆分的面授课不可以添加目标'
t.courseSchedule.courseGroup = '课程团队'
t.courseSchedule.courseIndex = '课程编号(时长)'
t.courseSchedule.courseCalculate = '课程合计'
t.courseSchedule.areaCalculate = '区域合计'
t.courseSchedule.siteCalculate = '场地合计'
t.courseSchedule.targetNum = '目标次数'
t.courseSchedule.scheduleTargetUpload = '排课目标批量导入'
t.courseSchedule.scheduleTemplate = '年度授课目标批量更新模板'
t.courseSchedule.editOneInfo = '请先保存后再进行编辑！'
t.courseSchedule.setModeInfo = '新增排课需选择设置模式！'
t.courseSchedule.setModeInfo2 = '按目标次数设置时需设置目标次数！'
t.courseSchedule.setModeInfo3 = '按月设置时需最少一个月份有值！'
t.courseSchedule.delTargetInfo = '是否删除该排课目标！'
t.courseSchedule.yearTemplateDownload = '年度授课目标'
t.courseSchedule.yearTemplateDownload2 = '批量更新课程目标结果导出'
t.courseSchedule.downloading = '正在下载中,请勿重复下载'
t.courseSchedule.courseDays = '课程天数'
t.courseSchedule.noValid = '已失效'
t.courseSchedule.downCourse = '已下架'
t.courseSchedule.noActivity = '不活动'
t.courseSchedule.choseCourseRealTime = '课程时长'
t.courseSchedule.importInfo = '批量更新课程目标'
t.courseSchedule.noSite = '无可用场地，请检查课程教室配置！'
t.courseSchedule.addScheduleInfo1 = '请先选择场地！'
t.courseSchedule.choseCourseTimeTips = '排课时长是因排课系统限制计算得出,该时长需要以0.5天为最小单位,自动向上取整'

//排课任务
t.courseTask = {}
t.courseTask.load = '读取'
t.courseTask.noValid = '已失效'
t.courseTask.execution = '执行'
t.courseTask.execution2 = '保存并执行'
t.courseTask.taskName = '排课任务名称'
t.courseTask.taskRemark = '备注'
t.courseTask.yearChose = '选择年度'
t.courseTask.monthChose = '选择月份'
t.courseTask.maxWorking = '最大连续授课天数(工作日)'
t.courseTask.maxWorkingRelease = '最大天数后休息天数(工作日)'
t.courseTask.startMonth = '开始月份'
t.courseTask.endMonth = '结束月份'
t.courseTask.yearFirstTrainer = '年度首排开发培训师'
t.courseTask.taskArrange = '排课区间'
t.courseTask.taskNum = '排课次数'
t.courseTask.loadTaskDownload = '排课任务详情'
t.courseTask.loadTaskDownload2 = '排课新增目标'
t.courseTask.newEditNum = '排课新增目标需填写排课次数！'
t.courseTask.editSuccess = '编辑成功！'
t.courseTask.delSuccess = '删除成功！'
t.courseTask.delSuccess2 = '放弃保存！'
t.courseTask.delTargetInfo = '是否删除该排课目标！'
t.courseTask.delTaskInfo = '是否放弃保存该新增排课目标任务！'
t.courseTask.delTaskInfo2 = '是否放弃保存该读取预设目标任务！'
t.courseTask.delTaskInfo3 = '是否放弃修改该读取预设目标任务！'
t.courseTask.delTaskInfo4 = '是否放弃修改该新增排课目标任务！'
t.courseTask.successLoad = '保存成功！'
t.courseTask.successLoad2 = '修改成功！'
t.courseTask.taskStatus = '排课任务状态'
t.courseTask.creator = '创建人'
t.courseTask.creator2 = '创建人用户ID'
t.courseTask.createTime = '创建时间'
t.courseTask.importStatus = '导入状态'
t.courseTask.addLoad = '通过年度授课目标创建新任务'
t.courseTask.addNew = '新建排课任务'
t.courseTask.taskType = '排课任务类型'
t.courseTask.updateTime = '更新时间'
t.courseTask.successRate = '排课成功率'
t.courseTask.successTargetNume = '成功次数/目标次数'
t.courseTask.money = '预估总费用（元）'
t.courseTask.isSchedule = '是否已导入排期'
t.courseTask.successAddNew = '排课目标保存成功！'
t.courseTask.successAddNew2 = '修改新建排课目标保存成功！'
t.courseTask.needInput1 = '排课任务名称不可为空！'
t.courseTask.needInput2 = '排课区间不可为空！'
t.courseTask.needInput3 = '最大连续授课天数不可为空！'
t.courseTask.needInput4 = '最大天数后休息天数不可为空！'
t.courseTask.needInput4 = '读取月份不可为空！'
t.courseTask.downNeedId = '需保存当前读取排课目标任务后，才可下载！'
t.courseTask.addTips = '选择周末可排课则可能会安排该课程周末上课,不会安排法定节假日'
t.courseTask.addCourseInfo = '课程校验未通过，请确保所有项已选择和输入！'
t.courseTask.copy = '复制'
t.courseTask.validLoad = '读取预设目标校验成功！'
t.courseTask.validAdd = '新增排课目标校验成功！'
t.courseTask.validLoadTask = '读取预设目标任务校验'
t.courseTask.noValidTask = '校验失败，请下载Excel查看具体原因！'
t.courseTask.noValidReason = '排课任务校验结果导出'
t.courseTask.importScheduleResult = '排课任务校验结果导出'
t.courseTask.addCourseSuccess = '新增成功！'
t.courseTask.addCourseSuccess2 = '新增课程成功！'
t.courseTask.validAddTask = '新增排课目标任务校验'
t.courseTask.executionSuccess = '执行成功！'
t.courseTask.executionFailed = '执行失败！'
t.courseTask.courseNewTemplate = '排课目标批量更新模板'
t.courseTask.courseNewTemplateDown = '排课目标批量导入结果'
t.courseTask.scheduleTargetUpload = '排课目标批量导入'
t.courseTask.noValidContinue = '该排课任务所需资源超过当前可用最大资源,是否继续'
t.courseTask.noValidContinue2 = '请下载Excel查看具体原因!'
t.courseTask.calcuteDetail = '计算明细'
t.courseTask.taskName2 = '任务名称'
t.courseTask.successNum = '成功期数/目标期数'
t.courseTask.estimateMoney = '预估总费用'
t.courseTask.resultTab1 = '排课结果汇总'
t.courseTask.resultTab2 = '排课结果明细'
t.courseTask.resultTab3 = '培训师日历'
t.courseTask.resultTab4 = '教室日历'
t.courseTask.coutType = '统计维度'
t.courseTask.area = '区域'
t.courseTask.areaNum = '区域成功次数/目标次数'
t.courseTask.areaSuccess = '区域排课成功率'
t.courseTask.startTime = '最早开始日期'
t.courseTask.endTime = '最晚结束日期'
t.courseTask.classSuccessNum = '分类成功次数/目标次数'
t.courseTask.classSuccessRate = '分类排课成功率'
t.courseTask.courseSuccessNum = '课程成功次数/目标次数'
t.courseTask.targetArea = '目标场地编号'
t.courseTask.targetAreaName = '目标场地名称'
t.courseTask.courseGroupFirst = '课程团队分类一级'
t.courseTask.courseGroupTwo = '课程团队分类二级'
t.courseTask.courseResult = '排课结果'
t.courseTask.courseGroupIndex = '课程组合编号'
t.courseTask.courseGroupName = '课程组合名称'
t.courseTask.courseGroupName = '课程组合名称'
t.courseTask.courseSuccessRate = '课程排课成功率'
t.courseTask.needTrainer = '培训师'
t.courseTask.needClass = '教室'
t.courseTask.resultDetail = '查看结果'
t.courseTask.copyInfo = '备注:复制的新建排课任务需点击上方确定按钮后,方可进行列表编辑操作!'
t.courseTask.estimateMoneyInfo = '预估总费用为排课任务计算中产生的预估值，仅包含培训费差旅费以及教室租用费的简单计算，费用发生以实际为准'
t.courseTask.failReason = '失败原因'
t.courseTask.trainerSuggest = '培训师建议'
t.courseTask.classSuggest = '教室建议'
t.courseTask.cancelRun = '取消执行'
t.courseTask.cancelSuccess = '取消执行成功'
t.courseTask.importSchedule = '导入排期'
t.courseTask.importScheduleInfo = '需选择至少一个排课结果！'
t.courseTask.importScheduleSuccess = '导入排期成功'
t.courseTask.downInfoTip = '请下载附件查看导入详情'
t.courseTask.importDetail = '导入排期结果导出'
t.courseTask.startEndTime = '起止时间'
t.courseTask.exportDetail = '导出明细'
t.courseTask.calendarTable = '日程表'
t.courseTask.calendarDay = '日'
t.courseTask.calendarMonth = '月'
t.courseTask.calendarWeek = '周'
t.courseTask.noImport = '未导入'
t.courseTask.existed = '已存在'
t.courseTask.trainerDetailExport = '培训师日历明细'
t.courseTask.trainerDetailExport2 = '培训师日历'
t.courseTask.classDetailExport = '教室日历明细'
t.courseTask.classDetailExport2 = '教室日历'
t.courseTask.stieName2 = '场地简称'
t.courseTask.cancelQueue = '取消排队'
t.courseTask.suggestInfo1 = '培训师建议:在该课程培训师关系增加与该培训师同等资质的培训师'
t.courseTask.suggestInfo2 = '教室建议为:在该课程教室关系增加与该教室同场地的教室'
t.courseTask.courseNameOrCode = '课程名称/课程代码'
t.courseTask.isImportdes = '是否导入排期'
t.courseTask.isImportY = '已导入'
t.courseTask.isImportN = '未导入'
t.courseTask.mutiImportInfo = '批量更新课程目标'
t.courseTask.downTaskInfo = '排课任务下载'
t.courseTask.taskExecutionTime = '任务执行时长(分钟)'
t.courseTask.siteDisableInfo = '备注：若非远程培训课程(含课程联排)若同时关联了实体场地和虚拟场地，设定目标时仅可选择实体场地。若课程联排中包含远程培训，则自动'
t.courseTask.siteDisableInfo2 = '排课会根据资源情况安排腾讯会议教室。'
t.courseTask.siteDisableInfo3 = '单独的远程培训课程若同时关联了实体场地和虚拟场地，设定目标时仅可选择腾讯会议场地，若需使用实体场地教室，请在自动排课结束后手动占用。'
t.courseTask.targetAreaFail = '目标场地'
t.courseTask.target = '排课目标'
t.courseTask.viewTarget = '查看目标'
t.courseTask.candlarInfo = '日历图示：课程编码_课程名称_所在城市_培训场地_尾标数字。'
t.courseTask.candlarInfo2 = '尾标数字代表一门课程在同一场地下的第n个排期。若一门课程在同一场地使用2个及以上培训师时，可通过尾标数字判断其为同一个排期。'
t.courseTask.candlarInfo3 = '尾标数字代表一门课程在同一场地下的第n个排期。若一门课程在同一场地使用2个及以上教室时，可通过尾标数字判断其为同一个排期。'
t.courseTask.taskStartEnd = '排课任务起止时间'
t.courseTask.resultImprove = '一键优化'
t.courseTask.resultImproveSuccess = '一键优化结果成功！'
t.courseTask.settingModeInfo = '按月设置:对不同月份设置排课目标，按排期结束时间所在月进行统计。按目标次数:设置该课程排课总次数，根据排课任务区间自动分配。'
t.courseTask.addSupplementary = '创建补排任务'
t.courseTask.isFirstTrainer = '是否优先使用本地培训师'
t.courseTask.isFirstTrainerInfo = '优先使用本地培训师不是强制条件,优先使用本地培训师在某些情况下会些许降低排课成功率'

//微课答疑
t.course.coursequestion = {}
t.course.coursequestion.courseName = '课程名称'
t.course.coursequestion.courseTrainer = '课程开发培训师'
t.course.coursequestion.createUser = '创建人'
t.course.coursequestion.brand = '品牌'
t.course.coursequestion.team = '业务团队'
t.course.coursequestion.status = '状态'
t.course.coursequestion.courseQaId = '问题 ID'
t.course.coursequestion.courseCreatBy = '创建人'
t.course.coursequestion.replyNum = '回复数'
t.course.coursequestion.qaDate = '提问时间'
t.course.coursequestion.content = '问题内容'
t.course.coursequestion.headImg = '图片'
t.course.coursequestion.operation = '操作'
t.course.coursequestion.imageShow = '查看'
t.course.coursequestion.reply = '回复'
t.course.coursequestion.shield = '屏蔽'
t.course.coursequestion.detail = '明细'
t.course.coursequestion.dialogReplyTitle = '回复'
t.course.coursequestion.dialogReplycourseCreatBy = '课程创建人'
t.course.coursequestion.dialogReplyId = '回复ID'
t.course.coursequestion.dialogReplyUser = '回复者'
t.course.coursequestion.dialogReplyDate = '回复时间'
t.course.coursequestion.dialogReplyContent = '回复内容'
t.course.coursequestion.dialogContinueReply = '继续回复'
t.course.coursequestion.img = '图片'
t.course.coursequestion.dialogReply = '回复'
t.course.coursequestion.dialogShield = '屏蔽'
t.course.coursequestion.dialogShielded = '已屏蔽'
t.course.coursequestion.deletePrompt = '删除提示'
t.course.coursequestion.allShieldPrompt = '确认要屏蔽该问题的所有回复信息吗？'
t.course.coursequestion.shieldPrompt = '你确定要屏蔽该课程么?'
t.course.coursequestion.shieldSuccess = '屏蔽成功!'
t.course.coursequestion.replySuccess = '回复成功!'
t.course.coursequestion.replyPrompt = '请输入回复内容'


//微课评价
t.course.coursecomment = {}
t.course.coursecomment.courseCode = '课程编号'
t.course.coursecomment.courseName = '课程名称'
t.course.coursecomment.brand = '品牌'
t.course.coursecomment.team = '业务团队'
t.course.coursecomment.trainer = '课程开发培训师'
t.course.coursecomment.creatRealName = '创建人'
t.course.coursecomment.commentCount = '评价数量'
t.course.coursecomment.commentTotalCount = '评价总数'
t.course.coursecomment.avgScore = '平均分'
t.course.coursecomment.view = '查看'
t.course.coursecomment.operation = '操作'
t.course.coursecomment.back = '返回'
t.course.coursecomment.export = '导出'
t.course.coursecomment.cancel = '取消'
t.course.coursecomment.confirm = '确认'
t.course.coursecomment.userName = '用户'
t.course.coursecomment.userNamePlaceholder = '请输入用户名称'
t.course.coursecomment.companyName = '经销商名称'
t.course.coursecomment.companyNamePlaceholder = '请输入经销商名称'
t.course.coursecomment.practicalScore = '实用性'
t.course.coursecomment.interestScore = '趣味性'
t.course.coursecomment.informationScore = '信息量'
t.course.coursecomment.content = '评价内容'
t.course.coursecomment.status = '状态'
t.course.coursecomment.contentTime = '评价时间'
t.course.coursecomment.contentTimePlaceholderStart = '开始日期'
t.course.coursecomment.contentTimePlaceholderEnd = '结束日期'
t.course.coursecomment.reply = '回复'
t.course.coursecomment.shield = '屏蔽'
t.course.coursecomment.dialogUserName = '学员账号'
t.course.coursecomment.dialogRealName = '学员名称'
t.course.coursecomment.dialogPracticalScore = '实用性'
t.course.coursecomment.dialogInterestScore = '趣味性'
t.course.coursecomment.dialogInformationScore = '信息量'
t.course.coursecomment.dialogcontent = '评价内容'
t.course.coursecomment.dialogreply = '回复'
t.course.coursecomment.dialogReplyTitle = '回复评价'
t.course.coursecomment.replyPrompt = '请输入回复内容'
t.course.coursecomment.replySuccess = '回复成功!'
t.course.coursecomment.replyFail = '回复失败!'
t.course.coursecomment.shieldConfirmPrompt = '屏蔽提示'
t.course.coursecomment.shieldPrompt = '确认要屏蔽该条评价信息吗？'
t.course.coursecomment.shieldSuccess = '屏蔽成功!'
t.course.coursecomment.shieldFail = '屏蔽失败!'
t.course.coursecomment.viewCourseCode = '课程编号:'
t.course.coursecomment.viewCourseName = '课程名称:'
t.course.coursecomment.viewAvgScore = '平均分:'
t.course.coursecomment.viewCommentTotalCount = '评价总数:'
t.course.coursecomment.exportConfirmPrompt = '导出提示'




//微课答疑
t.course.coursequestion = {}
t.course.coursequestion.courseName = '课程名称'
t.course.coursequestion.courseTrainer = '课程开发培训师'
t.course.coursequestion.createUser = '创建人'
t.course.coursequestion.brand = '品牌'
t.course.coursequestion.team = '业务团队'
t.course.coursequestion.status = '状态'
t.course.coursequestion.courseQaId = '问题 ID'
t.course.coursequestion.courseCreatBy = '创建人'
t.course.coursequestion.replyNum = '回复数'
t.course.coursequestion.qaDate = '提问时间'
t.course.coursequestion.content = '问题内容'
t.course.coursequestion.headImg = '图片'
t.course.coursequestion.operation = '操作'
t.course.coursequestion.imageShow = '查看'
t.course.coursequestion.reply = '回复'
t.course.coursequestion.shield = '屏蔽'
t.course.coursequestion.detail = '明细'
t.course.coursequestion.dialogReplyTitle = '回复'
t.course.coursequestion.dialogReplycourseCreatBy = '课程创建人'
t.course.coursequestion.dialogReplyId = '回复ID'
t.course.coursequestion.dialogReplyUser = '回复者'
t.course.coursequestion.dialogReplyDate = '回复时间'
t.course.coursequestion.dialogReplyContent = '回复内容'
t.course.coursequestion.dialogContinueReply = '继续回复'
t.course.coursequestion.img = '图片'
t.course.coursequestion.dialogReply = '回复'
t.course.coursequestion.dialogShield = '屏蔽'
t.course.coursequestion.dialogShielded = '已屏蔽'
t.course.coursequestion.deletePrompt = '删除提示'
t.course.coursequestion.allShieldPrompt = '确认要屏蔽该问题的所有回复信息吗？'
t.course.coursequestion.shieldPrompt = '你确定要屏蔽该课程么?'
t.course.coursequestion.shieldSuccess = '屏蔽成功!'
t.course.coursequestion.replySuccess = '回复成功!'
t.course.coursequestion.replyPrompt = '请输入回复内容'


//微课评价
t.course.coursecomment = {}
t.course.coursecomment.courseCode = '课程编号'
t.course.coursecomment.courseName = '课程名称'
t.course.coursecomment.brand = '品牌'
t.course.coursecomment.team = '业务团队'
t.course.coursecomment.trainer = '课程开发培训师'
t.course.coursecomment.creatRealName = '创建人'
t.course.coursecomment.commentCount = '评价数量'
t.course.coursecomment.commentTotalCount = '评价总数'
t.course.coursecomment.avgScore = '平均分'
t.course.coursecomment.view = '查看'
t.course.coursecomment.operation = '操作'
t.course.coursecomment.back = '返回'
t.course.coursecomment.export = '导出'
t.course.coursecomment.cancel = '取消'
t.course.coursecomment.confirm = '确认'
t.course.coursecomment.userName = '用户'
t.course.coursecomment.userNamePlaceholder = '请输入用户名称'
t.course.coursecomment.companyName = '经销商名称'
t.course.coursecomment.companyNamePlaceholder = '请输入经销商名称'
t.course.coursecomment.practicalScore = '实用性'
t.course.coursecomment.interestScore = '趣味性'
t.course.coursecomment.informationScore = '信息量'
t.course.coursecomment.content = '评价内容'
t.course.coursecomment.status = '状态'
t.course.coursecomment.contentTime = '评价时间'
t.course.coursecomment.contentTimePlaceholderStart = '开始日期'
t.course.coursecomment.contentTimePlaceholderEnd = '结束日期'
t.course.coursecomment.reply = '回复'
t.course.coursecomment.shield = '屏蔽'
t.course.coursecomment.dialogUserName = '学员账号'
t.course.coursecomment.dialogRealName = '学员名称'
t.course.coursecomment.dialogPracticalScore = '实用性'
t.course.coursecomment.dialogInterestScore = '趣味性'
t.course.coursecomment.dialogInformationScore = '信息量'
t.course.coursecomment.dialogcontent = '评价内容'
t.course.coursecomment.dialogreply = '回复'
t.course.coursecomment.dialogReplyTitle = '回复评价'
t.course.coursecomment.replyPrompt = '请输入回复内容'
t.course.coursecomment.replySuccess = '回复成功!'
t.course.coursecomment.replyFail = '回复失败!'
t.course.coursecomment.shieldConfirmPrompt = '屏蔽提示'
t.course.coursecomment.shieldPrompt = '确认要屏蔽该条评价信息吗？'
t.course.coursecomment.shieldSuccess = '屏蔽成功!'
t.course.coursecomment.shieldFail = '屏蔽失败!'
t.course.coursecomment.viewCourseCode = '课程编号:'
t.course.coursecomment.viewCourseName = '课程名称:'
t.course.coursecomment.viewAvgScore = '平均分:'
t.course.coursecomment.viewCommentTotalCount = '评价总数:'
t.course.coursecomment.exportConfirmPrompt = '导出提示'



t.policy = {}
t.policy.year = '年度'
t.policy.brand = '经销商品牌'
t.policy.trainCategory = '考核类型'
t.policy.trainCategoryCode = '考核类型代码'
t.policy.jobCategory = '项目分类'
t.policy.jobCategoryCode = '项目分类代码'
t.policy.downloadtemplate = '导出模板'
t.policy.startUpload = '开始上传'
t.policy.position = '主职职位'
t.policy.partTimePosition = '兼职职位'
t.policy.exportBase = '政策龄基础设置模板'

export default t
